<template>
    <a-modal :bodyStyle="{ maxHeight: '80vh', overflow: 'auto' }" :centered="state.centered" :title="state.modalTitle"
        width="70%" :open="open" :confirmLoading="state.confirmLoading" :keyboard="state.keyboard"
        :maskClosable="state.maskClosable" @ok="onFormSubmit" @cancel="cancelClick">
        <a-spin :spinning="state.loading" :tip="state.tip">
            <div style="padding: 20px 50px; font-size: 20px" v-if="state.isFirst">
                <div>请选择公司主体类型</div>
                <div class="category">
                    <div @click="initialTypeChange(1)" :class="formState.main_type == 1 ? 'check' : ''"
                        class="category-item company">公司</div>
                    <div @click="initialTypeChange(2)" :class="formState.main_type == 2 ? 'check' : ''"
                        class="category-item individual">个体户</div>
                    <div @click="initialTypeChange(3)" :class="formState.main_type == 3 ? 'check' : ''"
                        class="category-item proprietorship">独资企业</div>
                    <div @click="initialTypeChange(4)" :class="formState.main_type == 4 ? 'check' : ''"
                        class="category-item company">合伙企业</div>
                </div>
                <div class="d-flex">
                    <div class="flex-1 mr-2x">
                        <div>请选择平台简称</div>
                        <div class="category">
                            <a-select @change="selectPlatformChange" style="width: 100%"
                                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                v-model:value="formState.platform_id" placeholder="请选择平台简称">
                                <a-select-option class="relative" v-for="(item, index) in state.platformServicesList"
                                    :key="index" :value="item.id" :title="item.platform_name">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div class="flex-1">
                        <div>代理商姓名（选填）</div>
                        <div class="category">
                            <a-input v-model:value="formState.seller" placeholder="请输入代理商姓名（选填）"></a-input>
                        </div>
                    </div>
                </div>
            </div>
            <a-form ref="formRef" :model="formState" :rules="rules" v-bind="formLayout" v-show="!state.isFirst">
                <!-- 基础信息 -->
                <a-form-item name="is_heming" label="是否核名" :wrapperCol="{
                    xs: { span: 17 },
                    sm: { span: 17 }
                }">
                    <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.is_heming"
                        checked-children="已核名" un-checked-children="未核名"></a-switch>
                </a-form-item>
                <a-form-item label="名称核准文号" name="is_heming_num"
                    v-if="formState.is_heming == 1 && formState.is_ws_filiale == 2">
                    <a-input v-model:value="formState.is_heming_num"
                        placeholder="请输入名称核准文号或申请号"></a-input>名称核准文号填写样例：(国）登记内名预核字[2010]第<span
                        style="color: red">XXXX</span>号，请在输入框填写<span style="color: red">XXXX</span>
                </a-form-item>
                <div v-if="!state.isEdit">
                    <a-form-item label="平台简称" name="platform_id">
                        <a-select @change="selectPlatformChange"
                            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                            v-model:value="formState.platform_id" placeholder="平台简称">
                            <a-select-option :title="item" class="relative"
                                v-for="(item, index) in state.platformServicesList" :key="index" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item name="prefix" :colon="false" label="地址编号前缀"
                        v-if="state.prefixList && state.prefixList.length > 0" v-show="state.prefixList.length != 1">
                        <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                            v-model:value="formState.prefix" placeholder="地址编号前缀">
                            <a-select-option class="relative" v-for="(item, index) in state.prefixList" :key="index"
                                :value="item">
                                {{ item }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item name="postfix" :colon="false" label="地址编号后缀"
                        v-if="state.postfixList && state.postfixList.length > 0" v-show="state.postfixList.length != 1">
                        <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                            v-model:value="formState.postfix" placeholder="地址编号后缀">
                            <a-select-option class="relative" v-for="(item, index) in state.postfixList" :key="index"
                                :value="item">
                                {{ item }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </div>
                <div v-if="formState.platform_type == 2">
                    <a-form-item label="平台对接人微信号或其他(选填)" name="platform_wechat_account">
                        <a-input v-model:value="formState.platform_wechat_account" placeholder="请输入平台对接人微信号"></a-input>
                    </a-form-item>
                    <a-form-item label="平台对接人手机号(选填)" name="platform_person_mobile">
                        <a-input v-model:value="formState.platform_person_mobile" placeholder="请输入平台对接人手机号"></a-input>
                    </a-form-item>
                </div>
                <div v-if="state.isEdit">
                    <a-form-item name="is_auto" label="资料员是否可以录单了：">
                        <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.is_auto"
                            checked-children="资料已确定，资料员可以录单了" un-checked-children="还有资料未确定，资料员不要录单"></a-switch>
                        <span class="ml-2x"> 如不做单，请关闭此开关！ </span>
                    </a-form-item>

                    <a-form-item label="主体类型" name="main_type">
                        <a-radio-group v-model:value="formState.main_type" button-style="solid" disabled>
                            <a-radio-button :value="1">公司</a-radio-button>
                            <a-radio-button :value="2">个体户</a-radio-button>
                            <a-radio-button :value="3">独资企业</a-radio-button>
                            <a-radio-button :value="4">合伙企业</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="业务类型" required>
                        <a-radio-group v-model:value="formState.business_type" button-style="solid">
                            <a-radio-button :value="1">设立</a-radio-button>
                            <a-radio-button :value="2">同区迁入</a-radio-button>
                            <a-radio-button :value="3">跨区迁入</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item name="registration_type" label="注册类型" required>
                        <a-radio-group v-model:value="formState.registration_type" button-style="solid"
                            v-if="formState.platform_id == 10">
                            <a-radio-button :value="1">自己注册</a-radio-button>
                            <a-radio-button :value="2" :disabled="state.is_provide_adds == 2">他人注册</a-radio-button>
                        </a-radio-group>
                        <a-radio-group v-model:value="formState.registration_type" button-style="solid" v-else>
                            <a-radio-button :value="1">包注册</a-radio-button>
                            <a-radio-button :value="2" :disabled="state.is_provide_adds == 2">出裸地址</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="是否为分支机构" required>
                        <a-radio-group v-model:value="formState.is_filiale" button-style="solid">
                            <a-radio-button :value="1">是</a-radio-button>
                            <a-radio-button :value="2">否</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </div>
                <a-form-item :labelCol="{
                    xs: { span: 8 },
                    sm: { span: 7 }
                }" :wrapperCol="{
                    xs: { span: 16 },
                    sm: { span: 14 }
                }" label="请选择参加的优惠活动" name="is_activity"
                    v-if="state.platformObj.is_activity == 1 && state.platformObj.can_activity">
                    <a-badge-ribbon text="火热活动进行中" color="red"></a-badge-ribbon>

                    <a-radio-group v-model:value="formState.is_activity" style="padding-top: 6px">
                        <a-row v-for="(item, index) in state.platformObj.activity_list" :key="index">
                            <a-col :span="24" v-if="item.can_activity" style="margin-bottom: 20px">
                                <a-radio :value="item.value">参加{{ item.name }}</a-radio><a
                                    @click="showActivityDetail(item)">活动规则
                                    <QuestionCircleOutlined />
                                </a>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="24">
                                <a-radio :value="'bucanjia_0'">不参加活动
                                    <SmileOutlined />
                                </a-radio>
                            </a-col>
                        </a-row>
                    </a-radio-group>
                </a-form-item>
                <a-form-item name="entityNameToRegister" required label="待注册主体名称" :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 14 }">
                    <principal-name ref="principalName" :principalType="formState.main_type"
                        :business_type="formState.business_type" :isFiliale="formState.is_filiale"
                        :push_system="state.platformObj.push_system" :is_heming="formState.is_heming"
                        :company_type_id="formState.company_type_id" v-model:value="formState.entityNameToRegister">
                    </principal-name>
                    <a-button v-if="formState.business_type != 1" @click="onEnteringClick" type="primary"
                        :icon="h(ArrowDownOutlined)">手动导入</a-button>
                    <a-divider type="vertical" v-if="formState.business_type != 1" />
                    <a-button type="primary" :icon="h(CloudServerOutlined)" @click="safecheck"
                        v-if="formState.business_type != 1">自动导入</a-button>
                    <a-button v-if="formState.business_type == 1" @click="getrandcompanyname" type="primary"
                        :icon="h(DeploymentUnitOutlined)">获取字号</a-button>
                    <div v-if="state.companyName.length > 0" class="mt-1x">
                        <a-tag class="mr-1x mb-1x pointer" color="success" @click="selectCompanyNameChange(item)"
                            v-for="(item, index) in state.companyName" :key="index">{{ item }}</a-tag>
                    </div>
                </a-form-item>
                <a-form-item name="social_credit_code" label="统一社会信用代码">
                    <a-input v-model:value="formState.social_credit_code" placeholder="请输入统一社会信用代码"> </a-input>
                </a-form-item>
                <a-form-item label="主营行业" v-if="formState.entityNameToRegister.ondustry_representation_type">
                    {{ formState.entityNameToRegister.ondustry_representation_type }}
                </a-form-item>
                <div v-if="formState.business_type != 1">
                    <a-form-item name="reason_relocatio" label="迁入理由" required>
                        <a-input v-model:value="formState.reason_relocatio" placeholder="请输入迁入理由"> </a-input>
                    </a-form-item>
                    <a-form-item name="raw_address" label="公司原地址">
                        <a-textarea v-model:value="formState.raw_address" placeholder="请输入公司原地址"> </a-textarea>
                    </a-form-item>
                </div>
                <a-form-item v-if="formState.platform_type == 2" label="受理机关" name="company_authority">
                    <Authority v-model:value="formState.company_authority"> </Authority>
                </a-form-item>
                <a-form-item name="registered_address_list" v-show="formState.platform_type == 2"
                    :required="formState.platform_type == 2" label="注册地址(省市区)">
                    <AddressCascader :type="3" v-model:value="formState.registered_address_list"> </AddressCascader>
                </a-form-item>
                <a-form-item name="registration_address" v-if="formState.platform_type == 2" label="注册详细地址">
                    <a-input placeholder="请输入注册详细地址" v-model:value="formState.registration_address"></a-input>
                </a-form-item>
                <a-form-item name="pt_zipcode" v-if="formState.platform_type == 2" label="邮编">
                    <a-input placeholder="请输入地址邮编" v-model:value="formState.pt_zipcode"></a-input>
                </a-form-item>
                <a-form-item name="business_scope" :label="h(
                    'span',
                    { onClick: selectBusinessScope },
                    {
                        default: () => [
                            h('span', '经营范围'),
                            h(
                                Tooltip,
                                { title: '点击选取经营范围' },
                                {
                                    default: () => [h(InfoCircleOutlined, { onClick: selectBusinessScope, class: ['ml-x'] })]
                                }
                            )
                        ]
                    }
                )
                    ">
                    <a-textarea :auto-size="{ minRows: 3 }" :value="formState.business_scope" placeholder="请输入经营范围核验码"
                        @change="businessChange" @blur="verificationClick"> </a-textarea>
                    <a-button :disabled="state.verificationLoading" :loading="state.verificationLoading" class="mt-x"
                        type="primary" @click="verificationClick('click')"> 核验 </a-button>
                    <a-button class="mt-x ml-x" type="primary" @click="quchongBusinessScope">去重</a-button><a-divider
                        type="vertical" />
                    <a-button class="mt-x ml-x" type="primary" :icon="h(ApartmentOutlined)"
                        @click="formatAndVerify">格式化</a-button><a-divider type="vertical" /><a
                        @click="selectBusinessScope">点击选择经营范围</a>
                </a-form-item>
                <!-- 核验结果 -->
                <div style="margin-left: 29%" v-if="state.verificationErrorList.length > 0">
                    <p>以下经营范围核验失败,请修改之后重试</p>
                    <div>
                        <span v-for="(item, index) in state.verificationErrorList" :key="index" class="range "
                            :class="{ 'no-pass': item.type && item.type != 4 }">
                            <text v-if="typeof item == 'string'">
                                {{ item }}
                            </text>
                            <text v-else>
                                <span v-if="item.type == 4">
                                    <a-tag color="blue">没有这个经营范围项目: {{ item.msg }}
                                        <a @click="deleteBusinessScope(item, index)">
                                            <CloseCircleOutlined style="color: blue" />
                                        </a>
                                    </a-tag>
                                </span>
                                <span v-else>
                                    {{ item.msg }}
                                    <a @click="deleteBusinessScope(item, index)">
                                        <CloseCircleOutlined style="color: red" />
                                    </a>
                                </span>


                            </text>
                        </span>
                    </div>
                </div>
                <a-form-item label="工商预留手机号码" name="registration_mobile">
                    <a-input @change="
                        (v) => {
                            phoneOrLandlineChange(v, 'registration_mobile')
                        }
                    " :value="formState.registration_mobile" placeholder="请输入工商预留手机号码">
                        <template #suffix>
                            <a-tooltip title="此手机号码将提交给工商局,会有很多广告电话打进来,请谨慎留取">
                                <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                            </a-tooltip>
                        </template>
                    </a-input>
                </a-form-item>
                <!-- 自己的客户，才能编辑续费联系人 -->
                <div v-if="formState.self_customer == 1">
                    <a-form-item label="关联授权查看者手机号码">
                        <AssociateAuthorization type="number" v-model:value="formState.authorized_viewer_mobile"
                            placeholder="请输入关联授权查看者手机号码" suffixTitle="回车或失去焦点后可以添加多个关联授权查看手机号码" inputType="number">
                        </AssociateAuthorization>
                    </a-form-item>
                    <a-form-item label="续费联系人手机号码" name="xftel">
                        <a-input @change="
                            (v) => {
                                phoneChange(v, 'xftel')
                            }
                        " @blur="contactMobileBlur" v-model:value="formState.xftel" placeholder="请输入续费联系人手机号码">
                        </a-input>
                        <a-button :disabled="state.mobileBlurLoading" :loading="state.mobileBlurLoading"
                            @click="contactMobileBlur" class="mt-1x" type="primary">查询财务公司({{ state.filingsList.length
                            }})</a-button>
                        <div class="mt-1x">
                            <a-tag v-for="(item, index) in state.filingsList" :key="index" class="mr-1x mb-1x pointer"
                                :color="item.status === 1 ? 'success' : 'error'"
                                @click="selectFilingsListChange(item)">{{
                                    item.company_name
                                }}</a-tag>
                        </div>
                    </a-form-item>
                    <a-form-item label="财务公司名称" name="finance_company_name" required>
                        <a-input v-model:value="formState.finance_company_name" placeholder="请输入财务公司名称"></a-input>
                    </a-form-item>
                    <a-form-item label="财务公司统一社会信用代码" name="finance_social_credit_code">
                        <a-input v-model:value="formState.finance_social_credit_code"
                            placeholder="请输入财务公司统一社会信用代码"></a-input>
                    </a-form-item>
                    <a-form-item label="财务公司对接人姓名" name="finance_contact_name" required>
                        <a-input v-model:value="formState.finance_contact_name" placeholder="请输入财务公司对接人姓名"></a-input>
                    </a-form-item>
                    <a-form-item label="财务公司对接人其他号码">
                        <AssociateAuthorization type="number" v-model:value="formState.finance_contact_phone"
                            placeholder="请输入财务公司对接人其他号码" suffixTitle="回车或失去焦点后可以添加多个财务公司对接人其他号码" inputType="number">
                        </AssociateAuthorization>
                    </a-form-item>
                    <a-form-item label="财务公司对接人微信昵称" name="finance_contact_wechat_nickname">
                        <a-input v-model:value="formState.finance_contact_wechat_nickname"
                            placeholder="请输入财务公司对接人微信昵称"></a-input>
                    </a-form-item>
                    <a-form-item label="财务公司对接人微信号" name="finance_contact_wechat_account">
                        <a-input v-model:value="formState.finance_contact_wechat_account"
                            placeholder="请输入财务公司对接人微信号"></a-input>
                    </a-form-item>


                    <a-form-item label="代理商姓名" name="seller" required>
                        <!-- 不可修改 -->
                        <a-input v-model:value="formState.seller" placeholder="请输入代理商姓名"></a-input>
                    </a-form-item>
                </div>
                <a-form-item label="续费联系人注册拿货价" :wrapperCol="{
                    xs: { span: 17 },
                    sm: { span: 17 }
                }" name="xflxr_zc_price">
                    <div class="d-flex" style="align-items: center">
                        <a-input class="mr-2x" type="number" addon-after="元" v-model:value="formState.xflxr_zc_price"
                            style="width: 200px" placeholder="请输入价格">
                        </a-input>
                        此数值为微信、支付宝支付时，【续费联系人】支付该主体时应该支付的【注册价格】
                    </div>
                    <div class="mt-1x">
                        <a class="mr-1x" @click="() => (formState.xflxr_zc_price = 200)">200</a>
                        <a class="mr-1x" @click="() => (formState.xflxr_zc_price = 250)">250</a>
                        <a @click="() => (formState.xflxr_zc_price = 300)">300</a>
                    </div>
                </a-form-item>

                <a-form-item label="续费联系人续费拿货价" :wrapperCol="{
                    xs: { span: 17 },
                    sm: { span: 17 }
                }" name="xflxr_xf_price" required>
                    <div class="d-flex" style="align-items: center">
                        <a-input class="mr-2x" type="number" addon-after="元" v-model:value="formState.xflxr_xf_price"
                            style="width: 200px" placeholder="请输入价格">
                        </a-input>
                        此数值为微信、支付宝支付时，【续费联系人】支付该主体时应该支付的【续费价格】
                    </div>
                </a-form-item>
                <a-form-item name="fee_standard" label="收费标准" required>
                    <a-radio-group v-model:value="formState.fee_standard" button-style="solid"
                        :disabled="formState.first_pay_time ? true : false"
                        @click="() => { state.loading = true; state.tip = '价格体系更新中...' }">
                        <a-radio-button :value="1">按年收费</a-radio-button>
                        <a-radio-button :value="2">一次性收费</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="税务身份" required>
                    <a-radio-group v-model:value="formState.is_ybr" button-style="solid"
                        :disabled="formState.first_pay_time ? true : false"
                        @click="() => { state.loading = true; state.tip = '价格体系更新中...'; }">
                        <a-radio-button :value="2">小规模纳税人</a-radio-button>
                        <a-radio-button :value="1">一般纳税人</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <template
                    v-if="state.exists && (state.exists.fee_standard != formState.fee_standard || state.exists.is_ybr != formState.is_ybr || state.exists.is_activity != formState.is_activity)">
                    <!-- 如果改变了则显示新的平台价格 -->
                    <a-form-item label="我的拿货价">
                        <div class="red" style="font-size: 20px" v-if="formState.platform_id != 10">￥{{
                            state.platformPrice.purchase_price }} 元</div>
                        <a-input v-else class="mr-2x" type="number" prefix="￥" suffix="元"
                            v-model:value="formState.purchase_price" style="width: 200px" placeholder="请输入价格">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="我的来年续费价格" v-if="formState.fee_standard === 1">
                        <div class="red" style="font-size: 20px" v-if="formState.platform_id != 10">￥{{
                            state.platformPrice.renew_price }} 元</div>
                        <a-input v-else class="mr-2x" type="number" prefix="￥" suffix="元"
                            v-model:value="formState.renew_price" style="width: 200px" placeholder="请输入价格"> </a-input>
                    </a-form-item>
                </template>
                <template v-else>
                    <!-- 如果没有改变，则显示原来录单的价格 -->
                    <a-form-item :label="'代理商【' + formState.seller + '】拿货价'">
                        <div v-if="state.showprice">
                            <div class="red" style="font-size: 20px" v-if="formState.platform_id != 10">
                                ￥{{ formState.fee_standard == 2 ? formState.dls_ycx_price : formState.registration_type
                                    == 1 ? formState.dls_bzc_price : formState.dls_luo_price }} 元
                                <EyeOutlined @click="state.showprice = false" />
                            </div>
                            <a-input v-else class="mr-2x" type="number" prefix="￥" suffix="元"
                                v-model:value="formState.purchase_price" style="width: 200px" placeholder="请输入价格">
                            </a-input>
                        </div>
                        <a v-if="!state.showprice">
                            <EyeInvisibleOutlined @click="state.showprice = true" />
                        </a>
                    </a-form-item>
                    <a-form-item :label="'代理商【' + formState.seller + '】来年续费价格'" v-if="formState.fee_standard === 1">
                        <div v-if="state.showprice">
                            <div class="red" v-if="formState.platform_id != 10" style="font-size: 20px">
                                ￥{{
                                    formState.dls_xf_price }} 元</div>
                            <a-input v-else class="mr-2x" type="number" prefix="￥" suffix="元"
                                v-model:value="formState.renew_price" style="width: 200px" placeholder="请输入价格">
                            </a-input>
                        </div>
                    </a-form-item>
                </template>

                <!-- 编辑展示 -->
                <div v-if="state.isEdit">
                    <a-form-item label="入驻开始日期" name="enter_starttime">
                        <a-date-picker :disabled="state.isEdit" v-model:value="formState.enter_starttime"
                            placeholder="选择入驻开始日期"></a-date-picker>
                    </a-form-item>
                    <a-form-item label="入驻到期日期" name="enter_endtime">
                        <a-date-picker :disabled="state.isEdit" v-model:value="formState.enter_endtime"
                            placeholder="选择入驻到期日期"></a-date-picker>
                    </a-form-item>
                    <a-form-item label="成立日期" name="founding_time" v-if="state.isEdit">
                        <a-date-picker :disabled="state.isEdit" v-model:value="formState.founding_time"
                            placeholder="选择成立日期"></a-date-picker>
                    </a-form-item>
                    <a-form-item label="核准日期" name="verify_time" v-if="state.isEdit || formState.business_type != 1">
                        <a-date-picker :disabled="state.isEdit" v-model:value="formState.verify_time"
                            placeholder="选择核准日期"></a-date-picker>
                    </a-form-item>
                </div>
                <a-form-item label="租赁合同的乙方名称" v-if="state.isEdit" name="yifang_name">
                    {{ formState.yifang_name }}
                </a-form-item>
                <!-- 人员表格 -->
                <div class="share-ownership" style="margin-top: 10px;">
                    <a-table class="ownership-table" :columns="state.columns"
                        :data-source="state.shareOwnershipTableData" :pagination="false">
                        <template #bodyCell="{ column, record, index, text }">
                            <template v-if="column.dataIndex === 'name'">
                                <span class="mr-1x">{{ record.name }}</span>
                                <a-tag color="#ff4d4f" v-if="record.investment_money > 0">股东</a-tag>
                                <div class="mt-x">
                                    {{ record.phone_number }}
                                </div>
                            </template>

                            <template v-if="column.dataIndex === 'id_card_number'">
                                <span class="mr-1x">{{ record.id_card_number || record.corporate_credit_code || '-'
                                }}</span>
                            </template>

                            <template v-if="column.dataIndex === 'position_ids'">
                                <div v-if="text?.length > 0">
                                    <div class="positionItem" v-for="(item, index) in text" :key="index">
                                        <a-tag color="cyan" v-if="positionDic.get(item)">
                                            <template v-if="item == 1 && formState.is_filiale == 1">负责人</template>
                                            <template
                                                v-else-if="item == 1 && formState.main_type == 4">执行事务合伙人</template>
                                            <template v-else>{{ positionDic.get(item) }}</template>
                                        </a-tag>
                                    </div>
                                </div>
                                <div v-else>
                                    <template v-if="formState.main_type == 4 && record.hehuo_is_frdb == 1"> <a-tag
                                            color="cyan">执行事务合伙人</a-tag></template>
                                    <template v-else>无</template>
                                </div>
                            </template>

                            <template v-if="column.dataIndex === 'investment_money'">
                                <span v-if="record.investment_money && record.investment_money > 0">{{
                                    record.investment_money }}万元</span>
                                <span v-else-if="record.is_shareholder == 1 && formState.is_filiale != 1">{{ text }}
                                    万元</span>
                                <span v-else-if="record.is_shareholder == 1 && formState.is_filiale == 1">-</span>
                                <span v-else>不占股</span>
                            </template>

                            <template v-if="column.dataIndex === 'subscribe_endtime'">
                                {{ record.investment_money && record.investment_money > 0 ?
                                    record.subscribe_endtime.substr(0, 10) : record.is_shareholder == 1 ? text.substr(0, 10)
                                        : '无' }}
                            </template>

                            <template v-if="column.dataIndex === 'options'">
                                <div>
                                    <a-button @click="editClick(record, index)" type="primary" size="small"
                                        class="mr-1x">编辑</a-button>
                                    <a-popconfirm title="确定删除?" @confirm="deleteChange(index)">
                                        <a-button size="small" type="primary" danger>删除</a-button>
                                    </a-popconfirm>
                                </div>
                            </template>
                        </template>
                    </a-table>
                    <!-- <div v-if="checkFullName"> -->
                    <a-button v-if="formState.main_type == 1 || formState.main_type == 4" class="add-button"
                        type="primary" @click="showInformationVisible" :icon="h(PlusOutlined)">添加人员</a-button>
                    <a-button
                        v-if="(formState.main_type == 2 || formState.main_type == 3) && state.shareOwnershipTableData.length < 1"
                        class="add-button" type="primary" @click="showInformationVisible">添加负责人</a-button>
                    <!-- </div> -->
                </div>
                <!-- 分公司特有的 -->
                <div v-if="formState.is_filiale == 1">
                    <a-form-item name="is_ws_filiale" label="是否为外省分公司">
                        <a-radio-group v-model:value="formState.is_ws_filiale" button-style="solid" disabled>
                            <a-radio-button :value="1">是</a-radio-button>
                            <a-radio-button :value="2">否</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="核算类型" name="filiale_alone">
                        <a-select v-model:value="formState.filiale_alone" placeholder="请选择分公司核算类型">
                            <a-select-option :value="1">独立核算</a-select-option>
                            <a-select-option :value="2">非独立核算</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="所属行业" name="hangye_four" v-if="formState.is_ws_filiale == 1">
                        <HangyeFour v-model:value="formState.hangye_four"></HangyeFour>
                    </a-form-item>
                </div>
                <!-- 公司类型 -->
                <div v-if="formState.main_type == 1 || formState.main_type == 4">
                    <a-form-item label="公司类型" name="company_type_id">
                        <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                            v-model:value="formState.company_type_id" placeholder="请选择公司类型">
                            <a-select-option v-for="(item, index) in state.companyTypeList" :key="index"
                                :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </div>
                <!-- 文件信息 -->
                <div v-if="checkFullName">
                    <a-form-item name="letter_commitment_url" label="名称承诺书">
                        <a-form-item-rest>
                            <a-radio-group class="mb-2x" v-model:value="state.isPledgeId" button-style="solid">
                                <a-radio-button :value="1">自动上传</a-radio-button>
                                <a-radio-button :value="2">手动上传</a-radio-button>
                            </a-radio-group>
                        </a-form-item-rest>
                        <a-form-item-rest>
                            <Upload v-if="state.isPledgeId == 2"
                                :upload_path="`public/uploads/注册/${state.uploadPathObj.platformCompanyName}/客户资料/${state.uploadPathObj.mainTypeName}/${state.uploadPathObj.date}/${state.uploadPathObj.companyName}/`"
                                uploadType="picture-card" :limitation="1"
                                :customerName="formState.entityNameToRegister.full_name"
                                :accept="['png', 'jpg', 'jpeg', 'pdf']" v-model:value="formState.letter_commitment_url"
                                uploadText="上传名称承诺书"
                                :size="formState.main_type == 2 || formState.business_type != 1 ? 1 : 10">
                            </Upload>
                        </a-form-item-rest>
                    </a-form-item>
                    <a-form-item name="address_data_urls" label="地址资料">
                        <a-form-item-rest>
                            <a-radio-group class="mb-2x" v-model:value="formState.isLocalIpAddress"
                                button-style="solid">
                                <a-radio-button :value="1">自动上传</a-radio-button>
                                <a-radio-button :value="2">手动上传</a-radio-button>
                            </a-radio-group>
                        </a-form-item-rest>
                        <a-form-item-rest>
                            <Upload
                                :upload_path="`public/uploads/注册/${state.uploadPathObj.platformCompanyName}/客户资料/${state.uploadPathObj.mainTypeName}/${state.uploadPathObj.date}/${state.uploadPathObj.companyName}/`"
                                v-if="formState.isLocalIpAddress == 2" :accept="['png', 'jpg', 'jpeg', 'pdf']"
                                :customerName="formState.entityNameToRegister.full_name" uploadType="picture-card"
                                :limitation="99" v-model:value="formState.address_data_urls" uploadText="上传地址资料"
                                :size="formState.main_type == 2 || formState.business_type != 1 || formState.is_ws_filiale == 1 ? 1 : 10">
                            </Upload>
                            <a-button v-if="formState.isLocalIpAddress == 2 && formState.address_data_urls?.length == 0"
                                type="primary" :loading="state.dzh_zip_loading"
                                @click="createAddressClick(1)">生成</a-button>
                        </a-form-item-rest>
                    </a-form-item>
                    <a-form-item name="other_information_urls" label="其他资料">
                        <a-form-item-rest>
                            <a-radio-group class="mb-2x" v-model:value="state.isFileInformation" button-style="solid">
                                <a-radio-button :value="1">自动上传</a-radio-button>
                                <a-radio-button :value="2">手动上传</a-radio-button>
                            </a-radio-group>
                        </a-form-item-rest>
                        <a-form-item-rest>
                            <Upload
                                :upload_path="`public/uploads/注册/${state.uploadPathObj.platformCompanyName}/客户资料/${state.uploadPathObj.mainTypeName}/${state.uploadPathObj.date}/${state.uploadPathObj.companyName}/`"
                                v-if="state.isFileInformation == 2" :accept="['png', 'jpg', 'jpeg', 'pdf']"
                                uploadType="picture-card" :limitation="99"
                                :customerName="formState.entityNameToRegister.full_name"
                                v-model:value="formState.other_information_urls" uploadText="上传其他资料"
                                :size="formState.main_type == 2 || formState.business_type != 1 ? 1 : 10">
                            </Upload>
                            <p style="color: red">如选择手动上传，不搞电信诈骗承诺书，经营范围范围承诺等法律法规需要的材料均需要手动上传</p>
                            <a-button
                                v-if="state.isFileInformation == 2 && formState.other_information_urls?.length == 0"
                                :loading="state.dzh_zip_loading" type="primary"
                                @click="createAddressClick(2)">生成</a-button>
                        </a-form-item-rest>
                    </a-form-item>

                    <a-form-item v-if="state.isEdit || formState.business_type != 1" name="business_license_urls"
                        label="营业执照正副本或遗失声明">
                        <Upload
                            :upload_path="`public/uploads/注册/${state.uploadPathObj.platformCompanyName}/客户资料/${state.uploadPathObj.mainTypeName}/${state.uploadPathObj.date}/${state.uploadPathObj.companyName}/`"
                            :accept="['png', 'jpg', 'jpeg', 'pdf']" uploadType="picture-card" :limitation="99"
                            :customerName="formState.entityNameToRegister.full_name"
                            v-model:value="formState.business_license_urls" uploadText="上传营业执照正副本或遗失声明"
                            :size="formState.main_type == 2 || formState.business_type != 1 ? 1 : 10">
                        </Upload>
                    </a-form-item>
                </div>
                <a-form-item label="营业执照领取方式" @change="resetfeedback" required>
                    <a-radio-group v-model:value="formState.licenAcceptType" button-style="solid">
                        <a-radio-button :value="3">自助机领取</a-radio-button>
                        <a-radio-button :value="2">工商局邮寄</a-radio-button>
                        <a-radio-button :value="1">到登记机关窗口领取</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="邮寄类型" v-if="formState.licenAcceptType != 2" required>
                    <a-radio-group v-model:value="formState.mailing_type" button-style="solid">
                        <a-radio-button :value="1">手动邮寄</a-radio-button>
                        <a-radio-button :value="2">自动邮寄</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item name="mailing_kdgs" label="快递公司" required v-if="formState.licenAcceptType != 2">
                    <a-radio-group v-model:value="formState.mailing_kdgs" button-style="solid">
                        <a-radio-button :value="1"><img :src="formState.mailing_kdgs == 2 ? jdIconBlack : jdIconWhite"
                                style="width: 16px; margin-top: -3px; margin-right: 5px" /> 京东快递 </a-radio-button>
                        <a-radio-button :value="2"><img :src="formState.mailing_kdgs == 1 ? sfIconBlack : sfIconWhite"
                                style="width: 16px; margin-top: -3px; margin-right: 5px" /> 顺丰快递 </a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="邮寄付款类型" v-if="formState.licenAcceptType != 2" required>
                    <a-radio-group v-model:value="formState.payment_type" button-style="solid">
                        <a-radio-button :value="1">寄付</a-radio-button>
                        <a-radio-button :value="2">到付</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <div v-if="formState.self_customer == 1">
                    <a-form-item label="证章收货人姓名" has-feedback :validate-status="checkdatastate.recipient_name"
                        :required="formState.licenAcceptType == 2 || formState.mailing_type == 2">
                        <div class="d-flex">
                            <a-input @change="
                                () => {
                                    if (formState.licenAcceptType == 2 || formState.mailing_type == 2) {
                                        checkdatastate.recipient_name = formState.recipient_name ? 'success' : 'error'
                                    } else {
                                        checkdatastate.recipient_name = formState.recipient_name ? 'success' : ''
                                    }
                                }
                            " class="mr-1x" placeholder="请输入证章收货人姓名"
                                v-model:value="formState.recipient_name"></a-input>
                            <a-button :loading="state.emailLoading" type="primary" @click="emailChange"
                                :icon="h(CloudServerOutlined)">自动获取邮寄信息</a-button>
                        </div>
                    </a-form-item>
                    <a-form-item label="证章收货人手机号码"
                        :required="formState.licenAcceptType == 2 || formState.mailing_type == 2" has-feedback
                        :validate-status="checkdatastate.recipient_mobile">
                        <a-input @change="
                            (v) => {
                                phoneChange(v, 'recipient_mobile')
                            }
                        " v-model:value="formState.recipient_mobile" placeholder="请输入证章收货人手机号码">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="证章收货人省市区"
                        :required="formState.licenAcceptType == 2 || formState.mailing_type == 2" has-feedback
                        :validate-status="checkdatastate.recipient_area_ids">
                        <AddressCascader v-model:value="formState.recipient_area_ids" @change="residenceChange">
                        </AddressCascader>
                    </a-form-item>
                    <a-form-item label="证章收货人地址"
                        :required="formState.licenAcceptType == 2 || formState.mailing_type == 2" has-feedback
                        :validate-status="checkdatastate.recipient_address">
                        <a-textarea placeholder="请输入证章收货人地址" :show-count="false"
                            v-model:value="formState.recipient_address" @change="receiveAddressChange" />
                        <a-button type="primary" @click="parseReceiveAddress"
                            :loading="state.parseReceiveAddressLoading" style="margin-top:5px"
                            :icon="h(ScanOutlined)">识别</a-button>
                    </a-form-item>
                    <a-form-item label="邮编" :required="formState.licenAcceptType == 2 || formState.mailing_type == 2">
                        <a-input placeholder="请输入邮编" v-model:value="formState.zipcode"></a-input>
                    </a-form-item>

                    <!-- 送章start -->
                    <a-form-item :label="h(
                        'span',
                        {},
                        {
                            default: () => [
                                h('span', '刻章自动下单'),
                                h(
                                    Tooltip,
                                    { title: '此处如选择自动，并上传了自拍照，则外勤将营业执照拍照上传的时候，系统将自动下刻章单并付款，无需客户手动下单，适用于送章的情况！' },
                                    {
                                        default: () => [h(InfoCircleOutlined, { class: ['ml-x'] })]
                                    }
                                )
                            ]
                        })" v-if="state.platformObj.issong_seal == 1">
                        <a-radio-group v-model:value="formState.kezhang_auto" button-style="solid">
                            <a-radio-button :value="1">自动</a-radio-button>
                            <a-radio-button :value="2">手动</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <SongZhang v-if="formState.kezhang_auto == 1 && state.platformObj.issong_seal == 1"
                        v-model:value="formState.kezhang_attach"
                        :upload_path="`public/uploads/注册/${state.uploadPathObj.platformCompanyName}/客户资料/${state.uploadPathObj.mainTypeName}/${state.uploadPathObj.date}/${state.uploadPathObj.companyName}/`">
                    </SongZhang>
                    <!-- 送章end -->
                </div>
                <a-form-item label="公司网址">
                    <a-input v-model:value="formState.website" placeholder="请输入公司网址"></a-input>
                </a-form-item>
                <a-form-item label="天眼查手机号码">
                    <AssociateAuthorization type="number" v-model:value="formState.tyc_tels" placeholder="请输入天眼查手机号码"
                        suffixTitle="回车或失去焦点后可以添加多个关联授权查看手机号码" inputType="number">
                    </AssociateAuthorization>
                </a-form-item>
                <a-form-item label="客户邮箱">
                    <a-input v-model:value="formState.data_accept_email" placeholder="请输入客户邮箱"></a-input>
                </a-form-item>
                <a-form-item name="pt_lly_phone" label="使用平台联络员手机号码" :labelCol="{
                    xs: { span: 4 },
                    sm: { span: 8 }
                }" :wrapperCol="{
                    xs: { span: 20 },
                    sm: { span: 16 }
                }" style="display: flex" v-if="formState.main_type != 2">
                    <a-row>
                        <a-col :span="11" v-if="formState.pt_lly_phone_check == 1"><a-input
                                v-model:value="formState.pt_lly_phone" placeholder="请输入平台联络员手机号码"></a-input></a-col>
                        <a-col :span="13" style="padding-left: 10px"><a-switch :checkedValue="1" :unCheckedValue="2"
                                v-model:checked="formState.pt_lly_phone_check" checked-children="使用"
                                un-checked-children="不使用"></a-switch></a-col>
                    </a-row>
                </a-form-item>
                <a-form-item v-if="props.tableColumnsData?.id" label="主管机关" name="company_authority" required>
                    <Institution v-model:value="formState.company_authority"></Institution>
                </a-form-item>
                <!-- 西安系统不需要录的内容 -->
                <div v-if="state.platformObj.push_system != 2">
                    <a-form-item label="电子化录单账号是否自定义" name="dzh_account_id_diy" required>
                        <a-radio-group v-model:value="formState.dzh_account_id_diy" button-style="solid">
                            <a-radio-button :value="2">默认使用平台电子化账号</a-radio-button>
                            <a-radio-button :value="1">自定义</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="代办人身份证姓名" name="dzh_account_id" v-if="formState.dzh_account_id_diy == 1">
                        <DzhAccountPick v-model:value="formState.dzh_account_id"></DzhAccountPick>
                        <a @click="addAccount">新增电子化账号</a>
                    </a-form-item>
                    <a-form-item label="代办人身份" name="agenttype" required>
                        <a-radio-group v-model:value="formState.agenttype" button-style="solid">
                            <a-radio-button value="01">登记代理行业从业人员</a-radio-button>
                            <a-radio-button value="02">经营主体登记备案的登记联络员</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </div>
                <a-form-item label="备注(保密,仅自己可见)" name="remark">
                    <a-textarea type="textarea" v-model:value="formState.remark" placeholder="请输入备注"></a-textarea>
                </a-form-item>
                <a-form-item label="通用备注" name="common_remark">
                    <a-textarea type="textarea" v-model:value="formState.common_remark"
                        placeholder="请输入备注"></a-textarea>
                </a-form-item>
                <a-form-item label="微信服务群（优先反馈）" name="weixinquun">
                    <a-input v-model:value="formState.weixinqun" placeholder="请输入微信服务群（优先反馈）"
                        suffixTitle="开启客户端后，可以自动给客户微信群发消息，用于反馈进度，发送章程，发送营业执照，发送提醒等"></a-input>
                </a-form-item>
            </a-form>
        </a-spin>
        <!-- 公司添加人员 -->
        <employment-modal :business_type="formState.business_type" :company_area_name="state.company_area_name"
            :shareOwnershipTableData="state.shareOwnershipTableData"
            v-if="state.employmentVisible && (formState.main_type == 1 || formState.main_type == 4)"
            @cancel="employmentCancel" @change="employmentChange" :isEdit="state.isEdit"
            :uploadPathObj="state.uploadPathObj" :employmentData="state.employmentData"
            :platform_id="formState.platform_id" :position="state.positionList" :isFiliale="formState.is_filiale"
            :customerName="formState.entityNameToRegister.full_name" :main_type="formState.main_type"
            :registration_mobile="formState.registration_mobile" :companyTypeList="state.companyTypeList"
            :push_system="state.platformObj.push_system">
        </employment-modal>
        <!-- 个体户添加人员 -->
        <individual-business-modal
            v-if="state.employmentVisible && (formState.main_type == 2 || formState.main_type == 3)"
            :uploadPathObj="state.uploadPathObj" @cancel="employmentCancel" :isEdit="state.isEdit"
            @change="individualChange" :customerName="formState.entityNameToRegister.full_name"
            :platform_id="formState.platform_id" :employmentData="state.employmentData" :main_type="formState.main_type"
            :registration_mobile="formState.registration_mobile">
        </individual-business-modal>
    </a-modal>
    <!-- 活动的详情 -->
    <a-modal v-model:open="state.activityDetailVisible" :title="state.platformObj.name + '活动详情：'"
        @ok="activityDetailCancel" width="60%">
        <div v-html="state.activityDetail"></div>
    </a-modal>
    <Dzh-Account-Modal @cancel="dzhAccountCancel" @change="dzhAccountChange" v-if="state.dzhAccountVisible">
    </Dzh-Account-Modal>
</template>

<script lang="ts" setup>
import baseService from '@/utils/http/axios'
import Authority from './components/Authority.vue'
import { InfoCircleOutlined, EyeInvisibleOutlined, EyeOutlined, UpOutlined, CloseCircleOutlined, SmileOutlined, ScanOutlined, CloudServerOutlined, DeploymentUnitOutlined, ArrowDownOutlined, QuestionCircleOutlined, PlusOutlined, ApartmentOutlined } from '@ant-design/icons-vue'
import EmploymentModal from './components/form/EmploymentModal.vue'
import IndividualBusinessModal from './components/form/IndividualBusinessModal.vue'
import cloneDeep from 'lodash.clonedeep'
import PrincipalName from './components/form/PrincipalName.vue'
import Upload from '@/components/base/Upload.vue'
import SongZhang from './components/form/SongZhang.vue'
import Institution from '../platformManagement/components/Institution.vue'
import AddressCascader from '@/components/base/AddressCascader.vue'
import HangyeFour from './components/form/HangyeFour.vue'
import AssociateAuthorization from '@/components/base/AssociateAuthorization.vue'
import DzhAccountModal from './../dzhAccount/add.vue'
import sfIconBlack from '@/assets/icons/sf-icon-black.png'
import sfIconWhite from '@/assets/icons/sf-icon-white.png'
import jdIconBlack from '@/assets/icons/jd-icon-black.png'
import jdIconWhite from '@/assets/icons/jd-icon-white.png'
import DzhAccountPick from '@/components/base/DzhAccountPick.vue'
import { reactive, onMounted, onUnmounted, nextTick, h, ref, onBeforeUnmount, watch, computed } from 'vue'
import { message, Modal, Empty } from 'ant-design-vue'
import { Tooltip } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import dayjs from 'dayjs'
import { mobileRequiredValidator, mobileOrLandlineRequiredValidator, mobileValidator, parseAddress } from '@/utils/util'
import ls from '@/utils/Storage'
import { businessScopeToArr, businessScopeToStr } from './customerFn'
const UserInfo = ls.get('USER_INFO')
const emit = defineEmits(['ok', 'cancel'])
import { useStore } from 'vuex'
const $store = useStore()
const formRef = ref()
const principalName = ref()
const checkdatastate = reactive<any>({})
// 防抖器
let timer: any = null
let timer2: any = null
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
// 定时器
let interval
onBeforeUnmount(() => {
    clearInterval(interval)
})
// 股份预览表格
const companyColumns = [
    {
        title: '姓名',
        dataIndex: 'name',
        width: 140
    },
    {
        title: '身份证号码/社会信用代码',
        dataIndex: 'id_card_number',
        width: 200
    },
    {
        title: '担任职位',
        dataIndex: 'position_ids',
        width: 250
    },

    {
        title: '出资金额',
        dataIndex: 'investment_money',
        width: 130
    },
    {
        title: '认缴期限',
        dataIndex: 'subscribe_endtime',
        width: 130
    },
    {
        title: '操作',
        dataIndex: 'options',
        width: 200
    }
]
// 个人表格
const individualityColumns = [
    {
        title: '姓名',
        dataIndex: 'name',
        width: 130,
        scopedSlots: { customRender: 'name' }
    },
    {
        title: '身份证号码',
        dataIndex: 'id_card_number',
        width: 130,
        scopedSlots: { customRender: 'id_card_number' }
    },
    {
        title: '住所',
        dataIndex: 'address',
        width: 130,
        scopedSlots: { customRender: 'address' }
    },
    {
        title: '电话号码',
        dataIndex: 'phone_number',
        width: 130,
        scopedSlots: { customRender: 'phone_number' }
    },
    {
        title: '投资数额',
        dataIndex: 'investment_money',
        scopedSlots: { customRender: 'investment_money' },
        width: 130
    },
    {
        title: '操作',
        dataIndex: 'options',
        scopedSlots: { customRender: 'options' },
        width: 130
    }
]
const positionDic = new Map([
    [1, '法定代表人'],
    [2, '执行公司事务的董事'],
    [3, '经理'],
    [4, '监事'],
    [5, '财务负责人'],
    [6, '联络员'],
    [7, '负责人'],
    [8, '财务负责人联络员']
])
const checkFullName = computed(() => {
    const value = formState.entityNameToRegister
    if (!value || !value.organizational_form) {
        return false
    }
    if (formState.is_filiale == 1) {
        if (!value.filiale_full_name || (!value.name_word_mark && value.no_word != 1)) {
            return false
        }
    } else {
        if (!value.name_division || !value.name_word_mark || !value.ondustry_representation) {
            return false
        }
    }
    if (formState.main_type == 2) {
        state.uploadPathObj.mainTypeName = '个体户'
    } else if (formState.main_type == 3) {
        state.uploadPathObj.mainTypeName = '个人独资企业'
    } else if (formState.main_type == 4) {
        state.uploadPathObj.mainTypeName = '合伙企业'
    } else {
        state.uploadPathObj.mainTypeName = '公司'
    }
    state.uploadPathObj.companyName = formState.entityNameToRegister.full_name
    return true
})
// 主体名称自定义判断
const checkEntityNameToRegister = (rule, value: any) => {
    if (!value) {
        return Promise.reject('请填写主体名称')
    }
    if (!value.organizational_form) {
        return Promise.reject('请输入组织形式')
    }
    //   if (formState.main_type == 1 && formState.business_type == 1 && formState.registration_type == 1 && value.name_division?.includes('市')) {
    // let list = value.name_division.split('市')
    // if (list[1].length > 0) {
    //   return Promise.reject('名称区划不正确')
    // }
    //   }
    if (formState.is_filiale == 1) {
        if (!value.filiale_full_name) {
            return Promise.reject('请输入总公司名称')
        }
        if (!value.name_word_mark && value.no_word != 1) {
            return Promise.reject('请输入字号')
        }
    } else {
        if (!value.name_division) {
            return Promise.reject('请输入名称区划')
        }
        if (!value.name_word_mark) {
            return Promise.reject('请输入字号')
        }

        if (!value.ondustry_representation) {
            return Promise.reject('请输入行业表述')
        }
    }
    return Promise.resolve()
}
const letter_commitment_url = (rule, value) => {
    if (state.isPledgeId == 2) {
        if (!value) {
            return Promise.reject('请上传名称承诺书')
        }
    }
    return Promise.resolve()
}
const address_data_urls = (rule, value) => {
    if (formState.isLocalIpAddress == 2) {
        if (!value) {
            return Promise.reject('请上传地址资料')
        }
    }
    return Promise.resolve()
}
const other_information_urls = (rule, value) => {
    if (state.isFileInformation == 2) {
        if (!value) {
            return Promise.reject('请上传其他资料')
        }
    }
    return Promise.resolve()
}
const rules: Record<string, Rule[]> = {
    platform_id: [{ required: true, message: '选择平台' }],
    prefix: [{ required: true, message: '请选择地址编号前缀' }],
    postfix: [{ required: true, message: '请选择地址编号后缀' }],
    entityNameToRegister: [{ validator: checkEntityNameToRegister }],
    registration_address: [{ required: true, message: '请输入注册详细地址' }],
    business_scope: [{ required: true, message: '请填写经营范围' }],
    registration_mobile: [{ required: true, validator: mobileOrLandlineRequiredValidator }],
    recipient_mobile: [{ required: true, validator: mobileValidator }],
    xftel: [{ required: true, validator: mobileRequiredValidator }],
    xflxr_zc_price: [{ required: true, message: '请输入工商合同展示价格' }],
    company_type_id: [{ required: true, message: '请选择公司类型' }],
    hangye_four: [{ required: true, message: '请选择公司所属行业' }],
    letter_commitment_url: [{ validator: letter_commitment_url }],
    address_data_urls: [{ validator: address_data_urls }],
    other_information_urls: [{ validator: other_information_urls }],
    dls_bzc_price: [{ required: true, message: '请输入注册价格' }],
    dls_xf_price: [{ required: true, message: '请输入来年续费价格' }]
}
interface formState {
    main_type: number | undefined
    platform_type: number | null
    registration_type: number
    business_type: number
    platform_id: number | undefined | null
    prefix: string | null
    is_heming_num: string | null
    social_credit_code: string | null
    reason_relocatio: string | null
    postfix: string | null
    entityNameToRegister: any
    registration_mobile: string
    registered_address_list: string | undefined
    registration_address: string | null
    business_scope: string
    xftel: string
    authorized_viewer_mobile: string
    remark: string | null
    licenAcceptType: number
    enter_starttime: string | null
    enter_endtime: string | null
    verify_time: any
    founding_time: any
    recipient_name: string | null
    recipient_mobile: string | null
    recipient_area_ids: string | undefined
    recipient_address: string | null
    zipcode: string | null
    mailing_kdgs: number
    mailing_type: number
    payment_type: number
    company_type_id: number | undefined
    letter_commitment_url: string | undefined
    address_data_urls: object[] | undefined
    other_information_urls: object[] | undefined
    website: string | null
    data_accept_email: string | null
    is_auto: number
    xflxr_zc_price: number
    fee_standard: number
    seller: string
    dzh_account_id?: number | undefined
    company_authority?: any
    platform_wechat_account?: string | null
    platform_person_mobile?: string | null
    dls_bzc_price?: string | null
    dls_xf_price?: string | null
    finance_company_name: string
    finance_social_credit_code: string
    finance_contact_name: string
    finance_contact_phone: string
    finance_contact_wechat_nickname: string
    finance_contact_wechat_account: string
    person_list: any
    business_license_urls: any[]
    tyc_tels: string
    is_filiale: number
    is_ws_filiale: number
    hangye_four: string | undefined
    filiale_alone: number | null
    xflxr_xf_price: number
    purchase_price: number
    renew_price: number
    is_voluntarily_qt: number
    is_voluntarily_dz: number
    raw_address: string
    // 是否已经付款
    first_pay_time?: any
    upload_path: string
    yifang_name: string
    isLocalIpAddress: number
    is_heming: number
    self_customer: number
    pt_zipcode: string
    pt_lly_phone: string
    pt_lly_phone_check: number
    is_activity: string
    dzh_account_id_diy: number
    weixinqun: string
    agenttype: string
    kezhang_auto: number
    kezhang_attach: any
    is_ybr: number
}
let formState = reactive<formState>({
    upload_path: '',
    person_list: {},
    company_authority: [],
    main_type: undefined,
    platform_type: 1,
    registration_type: 1,
    is_heming_num: null,
    is_voluntarily_qt: 2,
    is_voluntarily_dz: 2,
    business_type: 1,
    platform_id: null,
    prefix: null,
    social_credit_code: null,
    reason_relocatio: null,
    postfix: null,
    entityNameToRegister: {
        name_division: ''
    },
    registration_mobile: '',
    registered_address_list: undefined,
    registration_address: null,
    business_scope: '',
    xftel: '',
    finance_company_name: '',
    finance_social_credit_code: '',
    finance_contact_name: '',
    finance_contact_phone: '',
    finance_contact_wechat_account: '',
    finance_contact_wechat_nickname: '',
    authorized_viewer_mobile: '',
    remark: null,
    licenAcceptType: 3,
    enter_starttime: null,
    enter_endtime: null,
    founding_time: null,
    verify_time: null,
    recipient_name: null,
    recipient_mobile: null,
    recipient_area_ids: undefined,
    recipient_address: null,
    zipcode: '410000',
    mailing_kdgs: 1,
    mailing_type: 1,
    payment_type: 1,
    company_type_id: undefined,
    letter_commitment_url: undefined,
    address_data_urls: [],
    other_information_urls: undefined,
    website: null,
    data_accept_email: null,
    is_auto: 1,
    xflxr_zc_price: 0,
    fee_standard: 1,
    seller: '',
    business_license_urls: [],
    tyc_tels: '',
    pt_zipcode: '410000',
    // 是否为分公司 1是 2否
    is_filiale: 2,
    is_ws_filiale: 2,
    hangye_four: undefined,
    filiale_alone: null,
    xflxr_xf_price: 300,
    purchase_price: 0,
    renew_price: 0,
    // 公司地址
    raw_address: '',
    yifang_name: '',
    isLocalIpAddress: 1, // 1自动上传 2手动上传
    is_heming: 2, // 1已核名 2未核名
    self_customer: 2,
    pt_lly_phone: '',
    pt_lly_phone_check: 2,
    is_activity: 'bucanjia_0', //是否参与排队免单活动
    dzh_account_id_diy: 1,//1平台默认2自定义
    weixinqun: '',
    agenttype: '01',
    kezhang_auto: 1,
    kezhang_attach: {},
    is_ybr: 2
})
const props = defineProps({
    open: {
        type: Boolean
    },
    tableColumnsData: {
        type: Object,
        default: () => null
    }
})
watch(
    () => props.open,
    (val) => {
        if (val) {
            if (!formState.seller) {
                formState.seller = UserInfo.idcard_name
            }
        }
    }
)


onMounted(() => {
    if (props.tableColumnsData?.id && !props.tableColumnsData.isCopy) {
        state.centered = true
        state.isFirst = false
        state.modalTitle = '编辑客户'
        state.loading = true
        state.isEdit = true
        formState.main_type = 1
    }
    // 初始化
    queryCompanyTypeList()
})
onUnmounted(() => {
    clearInterval(state.jyfwtimer)
})
interface platformServicesList {
    id: number
    name: string
    company_area_name: string
    company_city_name: string
    platform_name: string
    company_province_name: string
    pt_lly_phone: string
}
interface companyTypeList {
    name: string
    id: number
}
interface uploadPathObj {
    platformCompanyName: string
    date: string
    companyName: string
    mainTypeName: string
}
interface state {
    shareOwnershipTableData: any[]
    shareOwnershipTableDeleteData: object[]
    modalTitle: string
    isFirst: boolean
    loading: boolean
    keyboard: boolean
    maskClosable: boolean
    columns: object[]
    positionList: string[]
    employmentData: any
    employmentVisible: boolean
    isFileInformation: number
    isPledgeId: number
    verificationErrorList: object[]
    isEdit: boolean
    platformServicesList: platformServicesList[]
    companyTypeList: companyTypeList[]
    prefixList: string[]
    postfixList: string[]
    checkPass: boolean
    editIndex: number
    platformDataList: any[]
    filingsList: any[]
    company_area_name: string
    centered: boolean
    mobileBlurLoading: boolean
    emailLoading: boolean
    verificationLoading: boolean
    confirmLoading: boolean
    companyName: string[]
    emailList: any[]
    emailIndex: number
    is_provide_adds: number | null
    uploadPathObj: uploadPathObj
    principalType: number
    platformObj: any
    platformPrice: any
    activityDetailVisible: boolean
    activityDetail: string
    dzh_zip_id: number
    dzh_zip_loading: boolean
    jyfwtimer: any
    exists: any
    dzhAccountVisible: boolean //电子化账号
    oldshengshiqu: string
    tip: string
    parseReceiveAddressLoading: boolean
    showprice: boolean
}
const state = reactive<state>({
    // 选择的平台信息
    platformObj: {},
    platformPrice: {},
    principalType: 1,
    // 图片上传路径
    uploadPathObj: {
        date: dayjs().format('YYYYMM'),
        platformCompanyName: '',
        companyName: '',
        mainTypeName: ''
    },
    // 查询财务公司
    mobileBlurLoading: false,
    //   查询代理商
    confirmLoading: false,
    // 查询邮寄信息
    emailLoading: false,
    // 查询邮寄信息List
    emailList: [],
    emailIndex: 0,
    //   核验
    verificationLoading: false,
    platformDataList: [],
    //   财务公司List
    filingsList: [],
    // 占股人员表格
    shareOwnershipTableData: [],
    // 删除 人员信息表 存一份需要给后端
    shareOwnershipTableDeleteData: [],
    modalTitle: '新增客户',
    isFirst: true,
    loading: false,
    // esc是否关闭弹窗
    keyboard: true,
    // 居中布局model
    centered: false,
    // 蒙层是否关闭弹窗
    maskClosable: true,
    // 预览表格columns
    columns: [],
    //职位信息
    positionList: [],
    // 录用人员数据 暂存
    employmentData: {},
    employmentVisible: false,
    // 其他资料是否手动上传
    isFileInformation: 1,
    // 名称承诺书是否手动上传
    isPledgeId: 1,
    // 核验失败的范围list
    verificationErrorList: [],
    // 是否为编辑
    isEdit: false,
    // 平台信息
    platformServicesList: [],
    // 公司类型信息
    companyTypeList: [],
    // 前缀list
    prefixList: [],
    // 后缀list
    postfixList: [],
    // 经营范围
    checkPass: false,

    // 编辑的第几个
    editIndex: 0,
    // 选择平台区
    company_area_name: '',
    // 获取字号
    companyName: [],
    //   是否需要裸地址
    is_provide_adds: null,
    activityDetailVisible: false,
    activityDetail: '',
    dzh_zip_id: 0, //手动生成时先生成电子化资料
    dzh_zip_loading: false,
    jyfwtimer: null,
    exists: null,
    dzhAccountVisible: false,
    oldshengshiqu: '',
    parseReceiveAddressLoading: false,
    tip: '加载中...',
    showprice: false
})
watch(
    () => [
        formState.registration_type,
        formState.fee_standard,
        formState.is_ybr,
        formState.main_type,
        formState.platform_id,
        formState.business_type,
        state.isFirst,
        formState.postfix,
        formState.business_scope,
        formState.is_activity
    ],
    (val) => {
        if (state.isFirst) {
            return
        }
        const registration_type = formState.registration_type,
            fee_standard = formState.fee_standard,
            main_type = formState.main_type,
            platform_id = formState.platform_id,
            business_type = formState.business_type,
            postfix = formState.postfix,
            business_scope = formState.business_scope,
            is_activity = formState.is_activity
        if (!platform_id) {
            return
        }
        clearTimeout(timer)
        timer = setTimeout(() => {
            let requestParam = {
                url: `/admin/v1/getPlatformPrice?platform_id=${platform_id}&main_type=${main_type}&is_ybr=${formState.is_ybr}&registration_type=${registration_type}&fee_standard=${fee_standard}&business_type=${business_type}&postfix=${postfix}&business_scope=${business_scope}&is_activity=${is_activity}&is_ybr=${formState.is_ybr}&customer_id=${props.tableColumnsData?.id && !props.tableColumnsData.isCopy ? props.tableColumnsData.id : ''
                    }`,
                method: 'get'
            }
            baseService(requestParam)
                .then((res) => {
                    state.loading = false
                    formState.pt_lly_phone = res.data.pt_lly_phone
                    state.platformPrice = res.data
                    formState.purchase_price = res.data.purchase_price
                    formState.renew_price = res.data.renew_price
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('查询失败')
                    }
                })
        }, 1000)
    }
)
const queryDetail = () => {
    let requestParam = {
        url: `/admin/v1/customer/${props.tableColumnsData.id}/edit`,
        method: 'get'
    }
    baseService(requestParam)
        .then(async (res) => {
            //存一份原来的值
            state.exists = res.data
            // 主体类型获取
            initialTypeChange(res.data.main_type)
            state.uploadPathObj.date = dayjs(res.data.created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYYMM')
            if (res.data.letter_commitment_url?.length > 0) state.isPledgeId = 2
            if (res.data.address_data_urls?.length > 0) formState.isLocalIpAddress = 2
            if (res.data.other_information_urls?.length > 0) state.isFileInformation = 2
            if (res.data.pt_lly_phone) res.data.pt_lly_phone_check = 1

            // 获取人员表
            state.shareOwnershipTableData = [...res.data.person_list.fr, ...res.data.person_list.person]
            if (res.data.person_list.person.length > 0 && (res.data.main_type == 1 || res.data.main_type == 4)) {
                res.data.person_list.person.forEach((item, index) => {
                    state.positionList = [...state.positionList, ...item.position_ids]
                })
            }

            // 获得平台 前缀后缀
            let obj: any = {}
            for (let index = 0; index < state.platformServicesList.length; index++) {
                if (state.platformServicesList[index].id == res.data.platform_id) {
                    obj = state.platformServicesList[index]
                    state.uploadPathObj.platformCompanyName = state.platformServicesList[index].platform_name
                    if (!res.data.pt_lly_phone) res.data.pt_lly_phone = state.platformServicesList[index].pt_lly_phone
                }
            }
            state.prefixList = res.data.main_type == 2 ? obj.individual_address_number_prefix : obj.company_address_number_prefix
            state.postfixList = res.data.main_type == 2 ? obj.individual_address_number_postfix : obj.company_address_number_postfix
            // 编辑直接核验通过
            state.checkPass = true
            delete res.data.person_list
            nextTick(() => {
                if (res.data.verify_time) res.data.verify_time = dayjs(res.data.verify_time, 'YYYY-MM-DD')
                res.data.enter_endtime = dayjs(res.data.enter_endtime, 'YYYY-MM-DD')
                res.data.founding_time = dayjs(res.data.founding_time, 'YYYY-MM-DD')
                res.data.enter_starttime = dayjs(res.data.enter_starttime, 'YYYY-MM-DD')
                Object.assign(formState, res.data)
                state.platformObj = obj
                state.is_provide_adds = obj.is_provide_adds
                if (obj.is_provide_adds == 2) {
                    formState.registration_type = 1
                }
                state.loading = false
            })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            }
        })
}
// 公司类型 平台
const queryCompanyTypeList = () => {
    let requestParam = {
        url: '/admin/v1/customer/create',
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            state.companyTypeList = res.data.company_type
            state.platformServicesList = res.data.platform
            if (props.tableColumnsData?.id) {
                if (props.tableColumnsData.isCopy) {
                    copyDetail(props.tableColumnsData.id)
                } else {
                    state.centered = true
                    state.isFirst = false
                    state.modalTitle = '编辑客户'
                    state.loading = true
                    state.isEdit = true
                    formState.main_type = 1
                    queryDetail()
                }
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            }
        })
}

// 选择平台之后 获取前缀后缀
const selectPlatformChange = (res, e) => {
    // 公司类型
    let obj: any = null
    if (e?.title) {
        obj = e.title
    } else {
        obj = e
    }
    if (obj.name.includes('独立注册')) {
        formState.platform_type = 2 //手填完整地址
    } else {
        formState.platform_type = 1 //生成地址
    }
    // 平台的地址模式为手动，则自动为2
    formState.is_auto = obj.platform_addr_type
    state.uploadPathObj.platformCompanyName = obj.platform_name
    if (formState.main_type == 1) {
        state.prefixList = obj.company_address_number_prefix
        state.postfixList = obj.company_address_number_postfix
    } else {
        state.prefixList = obj.individual_address_number_prefix
        state.postfixList = obj.individual_address_number_postfix
    }
    nextTick(() => {
        state.platformObj = obj
        state.company_area_name = obj.company_area_name
        // 是否需要裸地址   如果为2则不能选择裸地址
        state.is_provide_adds = obj.is_provide_adds
        if (obj.is_provide_adds == 2) {
            formState.registration_type = 1
        }
        if (state.prefixList.length == 1) {
            formState.prefix = state.prefixList[0]
        } else {
            formState.prefix = null
        }
        if (state.postfixList.length == 1) {
            formState.postfix = state.postfixList[0]
        } else {
            formState.postfix = null
        }
        if (formState.main_type == 2) {
            principalName.value.inputChange(
                {
                    target: {
                        value: obj.company_city_name + obj.company_area_name
                    }
                },
                'name_division'
            )
            //   formState.entityNameToRegister.name_division = obj.company_city_name + obj.company_area_name
        }
        formState.pt_zipcode = obj.zipcode
    })
}
const businessChange = (v) => {
    let str = v.target.value.replaceAll(';', '；')
    str = v.target.value.replaceAll('\n', '')
    formState.business_scope = str
}
// 核验
const verificationClick = (type) => {
    if (state.verificationLoading) {
        return
    }
    if (type != 'click' && (formState.business_type != 1 || formState.registration_type != 1)) {
        return
    }
    let reg = /^\s+$/g
    // 不能为空格 不能为空
    let re = reg.test(formState.business_scope)
    if (!formState.business_scope || re) {
        message.warning('请填写经营范围之后再核验')
        return
    }
    let verificationString = formState.business_scope.replaceAll(';', '；')
    state.verificationLoading = true
    let requestParam = {
        url: '/admin/v1/customerVerify?str=' + verificationString + '&business_type=' + formState.business_type + '&platform_id=' + formState.platform_id + '&main_type=' + formState.main_type,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            state.verificationLoading = false

            if (res.data.error.length == 0) {
                message.success(res.msg)
                state.verificationErrorList = []
                state.checkPass = true
            } else {
                let errmsg = ''
                res.data.error.forEach((item) => {
                    if (typeof item == 'string') {
                        errmsg += item + '；'
                    } else {
                        errmsg += item.msg + '；'
                    }
                })
                message.error(
                    h('span', {
                        innerHTML: '以下经营范围不规范：' + errmsg
                    }),
                    6
                )
                state.checkPass = false
                state.verificationErrorList = res.data.error
            }
        })
        .catch((res) => {
            state.verificationLoading = false
            if (res.msg) {
                message.error(
                    h('span', {
                        innerHTML: res.msg
                    }),
                    6
                )
            }
        })
}
const contactMobileBlur = () => {
    if (state.mobileBlurLoading) {
        return
    }
    if (formState.seller == '朱尚') {
        if (formState.authorized_viewer_mobile) {
            if (!formState.authorized_viewer_mobile.includes('17336596383')) {
                formState.authorized_viewer_mobile = formState.authorized_viewer_mobile + ',17336596383'
            }
        } else {
            formState.authorized_viewer_mobile = '17336596383'
        }
    }
    formRef.value
        .validateFields('xftel')
        .then(() => {
            state.mobileBlurLoading = true
            let requestParam = {
                url: '/admin/v1/filingsList',
                method: 'post',
                data: { page: 1, limit: 'all', customer_tel: formState.xftel }
            }
            baseService(requestParam)
                .then((res) => {
                    state.mobileBlurLoading = false
                    if (res?.data?.list?.length === 1) {
                        let obj: any = res.data.list[0]
                        if (obj.status === 1) {
                            formState.finance_contact_name = obj.customer_name
                            formState.finance_contact_wechat_account = obj.wechat_id
                            formState.finance_contact_wechat_nickname = obj.wechat_name
                            formState.finance_company_name = obj.company_name
                            formState.finance_social_credit_code = obj.finance_social_credit_code
                        } else {
                            message.warn('公司暂时未通过审核,请联系管理员')
                        }
                    } else if (res?.data?.list?.length > 1) {
                        state.filingsList = res.data.list.filter((item) => {
                            if (item.status == 1) {
                                return item
                            } else {
                                message.warn('公司暂时未通过审核,请联系管理员')
                            }
                        })
                        let obj = res.data.list[0]
                        formState.finance_company_name = obj.company_name
                        formState.finance_social_credit_code = obj.finance_social_credit_code

                        formState.finance_contact_name = obj.customer_name
                        formState.finance_contact_wechat_account = obj.wechat_id
                        formState.finance_contact_wechat_nickname = obj.wechat_name
                    } else {
                        message.warn('该续费联系人手机号码没有绑定财务公司,请重新填写手机号码或者手动填写财务公司')
                    }
                })
                .catch((res) => {
                    state.mobileBlurLoading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('查询失败')
                    }
                })
        })
        .catch(() => { })
}
const selectFilingsListChange = (item) => {
    if (item.status === 1) {
        formState.finance_company_name = item.company_name
        formState.finance_social_credit_code = item.finance_social_credit_code
    } else {
        message.warn('公司暂时未通过审核,请联系管理员')
    }
}
const phoneChange = (v, type) => {
    if (v.target.value) {
        let str = v.target.value.replaceAll(/\D/g, '')
        //判断str是不是手机号码
        if (!/^1[23456789]\d{9}$/.test(str)) {
            checkdatastate[type] = 'error'
        } else {
            checkdatastate[type] = 'success'
            formState[type] = str
        }
    } else {
        checkdatastate.recipient_mobile = formState.licenAcceptType == 2 ? 'error' : ''
    }
}
const phoneOrLandlineChange = (v, type) => {
    if (v.target.value) {
        let str = v.target.value.replaceAll(/\D/g, '')
        //判断str是不是手机号码或座机号码
        if (!/^1[23456789]\d{9}$/.test(str) && !/^0\d{2,3}-?\d{7,8}$/.test(str)) {
            checkdatastate[type] = 'error'
        } else {
            checkdatastate[type] = 'success'
            formState[type] = str
        }
    } else {
        checkdatastate.recipient_mobile = formState.licenAcceptType == 2 ? 'error' : ''
    }
}
// 邮寄地址省市区
const residenceChange = (idList, value: any) => {
    let address = ''
    if (value) {
        checkdatastate.recipient_area_ids = 'success'
        //开始处理addresss
        address = `${value[0].name}${value[1].name}${value[2].name}`

        if (state.oldshengshiqu && formState.recipient_address) {
            formState.recipient_address = formState.recipient_address.replace(state.oldshengshiqu, '')
        }
        state.oldshengshiqu = address //把当前的选中的省市区赋值给一个变量
        formState.recipient_address = formState.recipient_address ? address + formState.recipient_address : address
        checkdatastate.recipient_address = formState.recipient_address == address ? 'error' : 'success'
    } else {
        checkdatastate.recipient_area_ids = formState.licenAcceptType == 2 ? 'error' : ''
    }
}
// 获取字号
const getrandcompanyname = () => {
    let requestParam = {
        url: '/admin/v1/getrandcompanyname?num=26',
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            state.companyName = res.data.msg
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取失败')
            }
        })
}
const copyDetail = (id) => {
    state.isFirst = false
    state.loading = true
    state.shareOwnershipTableData = []
    let requestParam = {
        url: `/admin/v1/customer/${id}/edit`,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            // 主体类型获取
            initialTypeChange(res.data.main_type)
            // 获取人员表
            state.shareOwnershipTableData = [...res.data.person_list.fr, ...res.data.person_list.person]
            if (res.data.person_list.person.length > 0 && (res.data.main_type == 1 || res.data.main_type == 4)) {
                res.data.person_list.person.forEach((item, index) => {
                    state.positionList = [...state.positionList, ...item.position_ids]
                })
            }
            if (res.data.platform_type == 1) {
                // 获得平台 前缀后缀
                let obj: any = {}
                for (let index = 0; index < state.platformServicesList.length; index++) {
                    if (state.platformServicesList[index].id == res.data.platform_id) {
                        obj = state.platformServicesList[index]
                        state.uploadPathObj.platformCompanyName = state.platformServicesList[index].platform_name
                    }
                }
                if (res.data.main_type == 2) {
                    state.prefixList = obj.individual_address_number_prefix
                    state.postfixList = obj.individual_address_number_postfix
                } else {
                    state.prefixList = obj.company_address_number_prefix
                    state.postfixList = obj.company_address_number_postfix
                }
            } else {
                for (let index = 0; index < state.platformServicesList.length; index++) {
                    if (state.platformServicesList[index].id == res.data.platform_id) {
                        state.uploadPathObj.platformCompanyName = state.platformServicesList[index].platform_name
                    }
                }
            }
            state.loading = false
            nextTick(() => {
                res.data.entityNameToRegister.name_word_mark = ''
                const newObject = Object.keys(formState).reduce((a, key) => ({ ...a, [key]: res.data[key] }), {})
                Object.assign(formState, newObject)
                state.loading = false
            })
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            }
        })
}

const selectCompanyNameChange = (val) => {
    principalName.value.inputChange(
        {
            target: {
                value: val
            }
        },
        'name_word_mark'
    )
}
// 录入
const onEnteringClick = () => {
    if (!formState.entityNameToRegister.full_name) {
        message.error('请输入公司主体名称后再去导入')
        return
    }
    clearInterval(interval)
    window.open('https://www.tianyancha.com/nsearch?key=' + formState.entityNameToRegister.full_name)
    interval = setInterval(() => {
        let formData = new FormData()
        formData.append('type', 'get')
        formData.append('companyname', formState.entityNameToRegister.full_name)

        let requestParam = {
            url: `/api/v1/daorucompany`,
            method: 'post',
            data: formData
        }
        baseService(requestParam)
            .then((res) => {
                state.checkPass = true
                clearInterval(interval)
                let data = JSON.parse(res.data.content)
                data.person_list.fr.forEach((item) => {
                    if (item.position_ids) {
                        item.position_ids = item.position_ids.filter((x) => !!x == true)
                    }
                })
                state.shareOwnershipTableData = data.person_list.fr
                formState.social_credit_code = data.social_credit_code
                formState.business_scope = data.business_scope
                formState.xftel = data.xftel
                formState.company_type_id = data.company_type_id
                formState.website = data.website
                formState.raw_address = data.raw_address
                formState.verify_time = dayjs(data.verify_time, 'YYYY-MM-DD')
                // formState.phone = data.phone
            })
            .catch((res) => { })
    }, 2000)
}
// 打开录用窗口
const showInformationVisible = () => {
    const value = formState.entityNameToRegister
    if (!value || !value.organizational_form) {
        message.warn('请填写完整的公司主体名称,才能选择人员')
        return
    }
    if (formState.is_filiale == 1) {
        if (!value.filiale_full_name || (!value.name_word_mark && value.no_word != 1)) {
            message.warn('请填写完整的公司主体名称,才能选择人员')
            return
        }
    } else {
        if (!value.name_division || !value.name_word_mark || !value.ondustry_representation) {
            message.warn('请填写完整的公司主体名称,才能选择人员')
            return
        }
    }
    state.employmentData = {}
    state.employmentVisible = true
}
// 关闭录用窗口
const employmentCancel = () => {
    state.employmentVisible = false
}
// 个体户保存录用信息
const individualChange = (res) => {
    if (res.type == 'add') {
        delete res.type
        state.shareOwnershipTableData.push(res)
    } else {
        delete res.type
        state.shareOwnershipTableData[0] = res
    }
    state.employmentVisible = false
}
// 生成地址资料
const createAddressClick = (type) => {
    state.dzh_zip_loading = true
    //名称和法定代表人姓名必须和数据库一致，不然生成电子化资料可能会有问题
    let full_name = formState.entityNameToRegister.full_name
    let fr_name = ''
    state.shareOwnershipTableData.forEach((item, index) => {
        //判断 item.position_ids 是否包含 1
        if (item.position_ids && item.position_ids.indexOf(1) != -1) {
            fr_name = item.name
        }
    })
    let requestParam = {
        url: `/admin/v1/getAddressDataTemplate`,
        method: 'post',
        data: {
            platform_id: formState.platform_id,
            customer_id: props.tableColumnsData?.id && !props.tableColumnsData.isCopy ? props.tableColumnsData.id : '',
            main_type: formState.main_type,
            bussiness_type: formState.business_type,
            full_name: full_name,
            fr_name: fr_name,
            dzh_zip_id: state.dzh_zip_id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.msg == 'async') {
                const mess = message.success('正在生成电子化资料！', 0)
                //异步处,根据zipid去查询是否转换完成
                let zipid = res.data
                let down = false //幂等
                let timer = setInterval(() => {
                    let requestParam = {
                        url: '/admin/v1/templateZipWait',
                        method: 'get',
                        params: {
                            id: zipid
                        }
                    }
                    baseService(requestParam).then((res2: any) => {
                        if (res2.msg == 'finish') {
                            //转换完成
                            clearInterval(timer)
                            if (!down) {
                                down = true //幂等
                                //转换完成，设置zipid
                                state.dzh_zip_id = zipid
                                setTimeout(mess, 0)
                                //再调用一下自己
                                createAddressClick(type)
                            }
                        }
                    })
                }, 2000)
                return
            }
            if (type == 1) {
                formState.is_voluntarily_qt = 1
            } else {
                formState.is_voluntarily_dz = 1
            }
            let list: any = []
            if (formState.main_type != 2) {
                if (type == 1) {
                    res.data.gsdzTemplate.forEach((item) => {
                        list.push(item.template_url.url)
                    })
                } else {
                    res.data.gsqtTemplate.forEach((item) => {
                        list.push(item.template_url.url)
                    })
                }
            } else {
                if (type == 1) {
                    res.data.gtdzTemplate.forEach((item) => {
                        list.push(item.template_url.url)
                    })
                } else {
                    res.data.gtqtTemplate.forEach((item) => {
                        list.push(item.template_url.url)
                    })
                }
            }
            if (list.length == 0) {
                message.info('平台该资料为空,请手动上传')
            } else {
                message.success('生成成功')
            }
            if (type == 1) {
                formState.address_data_urls = [...list]
            } else {
                formState.other_information_urls = [...list]
            }
            state.dzh_zip_loading = false
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('生成失败')
            }
            state.dzh_zip_loading = false
        })
}
// 保存录用信息
const employmentChange = (res, positionList) => {
    // 判断是否为新增
    if (res.type == 'add') {
        // 判断是否存在已经保存的人员信息
        const isRepeat = state.shareOwnershipTableData.some((item: any) => {
            if (res.stockholder == 2) {
                return item.id_card_number == res.id_card_number
            } else {
                return item.corporate_credit_code == res.corporate_credit_code
            }
        })
        if (isRepeat) {
            message.warning('该人员已经添加,不能重复')
            return
        }
        delete res.type
        state.shareOwnershipTableData.push(res)
        state.positionList = [...state.positionList, ...res.position_ids]
    } else {
        let stockholder = res.stockholder
        delete res.type
        if (stockholder == 2) {
            state.positionList = [...positionList, ...res.position_ids]
        }
        state.shareOwnershipTableData[state.editIndex] = res

        // 清空之后的职位表 再次合并
    }
    changeCompanyTypeId()
    //判断是否为外省分公司
    if (formState.is_filiale == 1) {
        const isWs = state.shareOwnershipTableData.some((item: any) => {
            if (item.stockholder == 1) {
                return item.is_bensheng == 2
            }
            return false
        })
        formState.is_ws_filiale = isWs ? 1 : 2
    }
    state.employmentVisible = false
}
const changeCompanyTypeId = () => {
    if (formState.main_type == 2) {
        formState.company_type_id = 11
    } else if (formState.main_type == 3) {
        formState.company_type_id = 12
    } else if (formState.main_type == 4) {
        //合伙企业
        let hehuo_types: number[] = [14, 15, 16, 17, 18, 19]
        let old_type_id = formState.company_type_id ? parseInt(formState.company_type_id + '') : 0
        if (hehuo_types.indexOf(old_type_id) == -1) {
            formState.company_type_id = 14
        }
    } else if (formState.is_filiale == 1) {
        //如果没有值，就给默认值
        let cti = formState.company_type_id ? parseInt(formState.company_type_id + '') : 0
        if ([6, 7, 8, 9, 10].indexOf(cti) == -1) {
            formState.company_type_id = 6
        }
    } else {
        // 公司类型
        let companyType: number | undefined = 1
        // 法人股东数量
        let legalPerson = 0
        let legalPerson_money = 0.0
        // 自然人 股东数量
        let shareholder = 0
        let shareholder_money = 0.0
        state.shareOwnershipTableData.forEach((item: any, index) => {
            //  存在统一社会信用代码则是法人股东
            if (item.corporate_credit_code) {
                legalPerson++
                legalPerson_money += Number(item.investment_money)
            } else {
                // 判断自然人股东是否占股
                if (item.is_shareholder == 1) {
                    shareholder++
                    shareholder_money += Number(item.investment_money)
                }
            }
        })
        if (legalPerson == 0) {
            //没有法人股东的
            companyType = shareholder == 1 ? 2 : 1
        } else {
            //有法人股东的
            if (legalPerson == 1 && shareholder == 0) {
                //跟随法人股东的性质来，有限责任公司(自然人投资或控股的法人独资)、有限责任公司（非自然人投资或控股的法人独资）
                companyType = undefined
            } else {
                //谁出钱多，就是哪种成分，如果法人股东出钱多，则是其他有限责任公司，反之
                if (legalPerson_money > shareholder_money) {
                    companyType = 5
                } else {
                    companyType = 1
                }
            }
        }
        formState.company_type_id = companyType
    }
}
// 编辑人员信息
const editClick = (data, index) => {
    state.editIndex = index
    state.employmentData = cloneDeep(data)
    state.employmentData.type = 'edit'
    state.employmentVisible = true
}
// 删除人员信息
const deleteChange = (index) => {
    if (state.isEdit) {
        // 删除 人员信息表 存一份需要给后端
        state.shareOwnershipTableDeleteData.push({ ...{ edit_code: 'del' }, ...state.shareOwnershipTableData[index] })
    }
    // 删除职位
    if (state.shareOwnershipTableData[index]?.position_ids) {
        state.shareOwnershipTableData[index].position_ids.forEach((val) => {
            state.positionList = state.positionList.filter((item) => item !== val)
        })
    }
    state.shareOwnershipTableData.splice(index, 1)
}
// 初始进入切换公司主体类型
const initialTypeChange = (val) => {
    if (state.confirmLoading) {
        return
    }
    formState.main_type = val
    if (state.isFirst) {
        onFormSubmit()
    }
    principalTypeChange({ target: { value: val } })
}
// 切换公司主体类型
const principalTypeChange = (val) => {
    if (val.target.value == 1) {
        formState.entityNameToRegister.name_division = ''
    }
    changeCompanyTypeId()
    if (state.shareOwnershipTableData.length > 0) {
        Modal.confirm({
            title: '有已经填写好的人员,切换后填写的人员将重置,是否继续?',
            onOk: () => {
                state.shareOwnershipTableData = []
                state.positionList = []
                if (val.target.value != 2) {
                    state.columns = companyColumns
                } else {
                    state.columns = individualityColumns
                }
                if (formState.platform_id) selectPlatformChange(formState.platform_id, state.platformObj)
                state.principalType = val.target.value
            },
            onCancel: () => {
                formState.main_type = state.principalType
            }
        })
    } else {
        if (val.target.value != 2) {
            state.columns = companyColumns
        } else {
            state.columns = individualityColumns
        }
        if (formState.platform_id) {
            selectPlatformChange(formState.platform_id, state.platformObj)
        }
        state.principalType = val.target.value
    }
}
// 公司名称字号
const selectBusinessScope = () => {
    let uuid = new Date().getTime() + '' + Math.floor(Math.random() * 1000)
    let backUrl = 'https://console.cskaiyela.com/hncskaiyela/admin/jyfw/' + uuid + '/'
    let backUrl2 = encodeURIComponent(backUrl)
    if (state.platformObj.push_system == 1) {
        window.open(
            'https://hnscjgj.amr.hunan.gov.cn:8022/jyfw/?backUrl=' + backUrl2,
            'newwindow2',
            'height=700, width=1000, top=300, left=300,toolbar=no, menubar=no, scrollbars=no, resizable=no, loca tion=no, status=no'
        )
    } else {
        window.open(
            'https://console.cskaiyela.com/xianjyfw/index.html?backUrl=' + backUrl2,
            'newwindow2',
            'height=700, width=1000, top=300, left=300,toolbar=no, menubar=no, scrollbars=no, resizable=no, loca tion=no, status=no'
        )
    }
    clearInterval(state.jyfwtimer)
    state.jyfwtimer = setInterval(() => {
        let requestParam = {
            url: '/admin/v1/checkjyfw',
            method: 'post',
            data: { id: uuid }
        }
        baseService(requestParam)
            .then((res: any) => {
                if (res.msg == 'ok') {
                    formState.business_scope = res.data
                    clearInterval(state.jyfwtimer)
                }
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败,请联系管理员')
                }
            })
    }, 2000)
}
//删除掉经营范围
const deleteBusinessScope = (item, index) => {
    let val = item.val
    let type = item.type
    let list = businessScopeToArr(formState.business_scope)
    if (type == 1) {
        //精准匹配
        list = list.filter((item, index) => {
            if (item.type == 0 && item.name == val) {
                return false
            }
            return true
        })
    } else if (type == 2) {
        //模糊匹配
        list = list.filter((item, index) => {
            if (item.type == 0) {
                if (item.name.indexOf(val) != -1) {
                    return false
                }
            }
            return true
        })
    }
    let newscope = businessScopeToStr(list)
    formState.business_scope = newscope
    state.verificationErrorList.splice(index, 1)
    verificationClick('click')
}
//去重经营范围
const quchongBusinessScope = () => {
    let list = businessScopeToArr(formState.business_scope)
    // 根据 name 去重，保留第一个出现的元素
    const list2 = list.filter((item, index, self) => index === self.findIndex((obj) => obj.name === item.name))
    let newscope = businessScopeToStr(list2)
    formState.business_scope = newscope
    verificationClick('click')
}

// 关闭
const cancelClick = (val) => {
    if (state.isEdit) {
        emit('cancel')
        return
    }
    if (!state.isFirst) {
        Modal.confirm({
            title: '是否确定关闭弹窗',
            onOk: () => {
                clearInterval(state.jyfwtimer)
                clearInterval(interval)
                emit('cancel')
            },
            okType: 'primary'
        })
    } else {
        emit('cancel')
    }
}
// 提交
const onFormSubmit = () => {

    //把formState.purchase_price转为数值

    if (formState.xflxr_zc_price < Number(formState.purchase_price)) {
        message.error('续费联系人的注册拿货价不能低于代理商的注册拿货价！')
        return
    }
    if (formState.xflxr_xf_price < Number(formState.renew_price)) {
        message.error('续费联系人的注续费拿货价不能低于代理商的续费拿货价！')
        return
    }


    if (state.isFirst) {
        if (state.confirmLoading) {
            return
        }
        if (!formState.main_type) {
            message.warning('请选择公司主体类型')
            return
        }
        if (!formState.platform_id) {
            message.warning('请选择平台简称')
            return
        }
        if (!formState.seller) {
            message.error('请输入代理商姓名')
            return
        }

        state.confirmLoading = true
        let requeryParam = {
            url: '/admin/v1/checkSeller?seller=' + formState.seller + '&platform_id=' + formState.platform_id,
            method: 'get'
        }
        baseService(requeryParam)
            .then((res: any) => {
                state.keyboard = false
                state.centered = true
                state.maskClosable = false
                state.isFirst = false
                state.confirmLoading = false
            })
            .catch((res) => {
                state.confirmLoading = false
                message.error(res?.msg ? res.msg : '确定失败，请联系管理员')
            })
        return
    }
    formRef.value
        .validate()
        .then(() => {
            let validate_position = [
                {
                    name: '法定代表人',
                    position_id: 1,
                    position_flag: 1
                },
                {
                    name: '执行公司事务的董事',
                    position_id: 2,
                    position_flag: 1
                },
                {
                    name: '经理',
                    position_id: 3,
                    position_flag: 1
                },
                {
                    name: '财务负责人',
                    position_id: 5,
                    position_flag: 1
                },
                {
                    name: '联络员',
                    position_id: 6,
                    position_flag: 1
                },
                {
                    name: '负责人',
                    position_id: 7,
                    position_flag: 1
                }
            ]
            state.shareOwnershipTableData.forEach((item, index) => {
                validate_position.forEach((val, valindex) => {
                    if (item.hasOwnProperty('position_ids')) {
                        if (item.position_ids.includes(val.position_id)) {
                            validate_position[valindex].position_flag = 0
                        }
                    }
                })
            })
            //如果平台默认是工商局邮寄&&不去线下领证，且选择的不是工商局邮寄则电子化账号必须自定义
            let licence_receive = formState.main_type == 2 ? state.platformObj.licence_receive_gt : state.platformObj.licence_receive_ngt
            let licence_receive_xianxia = formState.main_type == 2 ? state.platformObj.licence_receive_gt_xianxia : state.platformObj.licence_receive_ngt_xianxia
            if (licence_receive == 2 && licence_receive_xianxia != 1 && formState.licenAcceptType != 2 && formState.dzh_account_id_diy != 1 && formState.registration_type == 1) {
                message.error('平台默认工商局邮寄且不去线下领证，其他邮寄方式电子化账号必须自定义')
                return false
            }

            if (formState.business_type == 1) {
                //设立
                if (formState.main_type == 1) {
                    //公司
                    if (formState.is_filiale == 1) {
                        // 分公司
                        for (const item of [validate_position[0], validate_position[3], validate_position[4]]) {
                            if (item.position_flag == 1) {
                                if (item.name == '法定代表人') {
                                    message.error('请填写分公司负责人！')
                                } else {
                                    message.warning('【' + item.name + '】未填写，可能导致错误，建议修改！')
                                }
                            }
                        }
                    } else {
                        //非分公司
                        for (const item of [validate_position[0], validate_position[1], validate_position[2], validate_position[3], validate_position[4]]) {
                            if (item.position_flag == 1) {
                                message.warning('【' + item.name + '】未填写，可能导致错误，建议修改！')
                            }
                        }
                    }
                } else if (formState.main_type == 2) {
                    for (const item of [validate_position[0]]) {
                        if (item.position_flag == 1) {
                            message.error('请填写个体户负责人信息！')
                            return
                        }
                    }
                } else if (formState.main_type == 4) {
                    //合伙企业-法人股如果是执行事务合伙人，则需要填一个执行事务合伙人的代表
                    let errName: Array<string> = []
                    state.shareOwnershipTableData.forEach((item, index) => {
                        if (item.stockholder == 1 && item.hehuo_type == 2 && item.hehuo_is_frdb == 1) {
                            let hehuo_frdb_name = item.hehuo_frdb_name
                            let hehuo_frdb_num = item.hehuo_frdb_num
                            let haveName = state.shareOwnershipTableData.some((item, index) => {
                                return item.stockholder == 2 && item.name == hehuo_frdb_name && item.id_card_number == hehuo_frdb_num
                            })
                            if (!haveName) {
                                errName.push(hehuo_frdb_name)
                            }
                        }
                    })
                    if (errName.length > 0) {
                        message.error('请填写执行事务合伙人的代表：' + errName.join('、'))
                        return
                    }
                }
            }
            if (formState.business_type == 1 && formState.registration_type == 1) {
                // if (!state.checkPass) {
                //   message.warn('经营范围核验不通过,请修改重试')
                //   return
                // }
                let positionList: any[] = []
                console.log(state.shareOwnershipTableData)

                state.shareOwnershipTableData.forEach((item, index) => {
                    if (item.position_ids) {
                        positionList = [...positionList, ...item.position_ids]
                    }
                })
                if (formState.main_type == 1 && props.tableColumnsData?.id) {
                    if (formState.is_filiale == 1) {
                        // 分公司
                        if (!formState.filiale_alone) {
                            message.warning('请选择分公司核算类型')
                            return
                        }
                    } else {
                        // 出资金额
                        let price = 0
                        for (let index = 0; index < state.shareOwnershipTableData.length; index++) {
                            if (state.shareOwnershipTableData[index].investment_money) {
                                price = price + Number(state.shareOwnershipTableData[index].investment_money)
                            }
                        }

                        // 判断 公司主体名称为湖南的情况下 出资金额必须大于200W
                        if (formState.entityNameToRegister.name_division.substring(0, 2) == '湖南' && price < 200) {
                            message.warning('湖南公司出资金额必须大于200W')
                            return
                        }
                    }
                    if (formState.entityNameToRegister.name_division_position != 0 && formState.is_heming != 1) {
                        message.warning('地域排序换位置时，需先核名！')
                        return
                    }
                } else if (formState.main_type != 1 && state.shareOwnershipTableData.length < 1) {
                    message.error('请上传负责人信息')
                    return
                }
            }
            // 名称承诺书，地址资料，其他资料如果选择自动上传则清空图片
            if (state.isPledgeId == 1) {
                formState.letter_commitment_url = ''
            }
            if (formState.isLocalIpAddress == 1) {
                formState.address_data_urls = []
            }
            if (state.isFileInformation == 1) {
                formState.other_information_urls = []
            }
            // 构建人员信息 分为法人和自然人  当类型为个体的时候不存在法人
            formState.person_list = {
                fr: [],
                person: []
            }
            // 公司
            if (formState.main_type == 1 || formState.main_type == 4) {
                let tableDataList = [...state.shareOwnershipTableData, ...state.shareOwnershipTableDeleteData]
                tableDataList.forEach((item: any, index) => {
                    const {
                        name,
                        phone_number,
                        corporate_credit_code,
                        investment_money,
                        subscribe_endtime,
                        business_license_url,
                        stockholder_type_id,
                        business_term,
                        registerno,
                        registermoney,
                        stockholder_djjg,
                        edit_code,
                        id,
                        area_ids,
                        address,
                        frdbname,
                        frdb_id_card_number,
                        is_bensheng,
                        hehuo_type,
                        hehuo_is_frdb,
                        hehuo_license,
                        hehuo_frdb_name,
                        hehuo_frdb_num
                    } = item
                    // 1为法人 2为自然人
                    if (item.stockholder == 1) {
                        formState.person_list.fr.push({
                            // 法人名称
                            name,
                            // 法人信用代码
                            corporate_credit_code,
                            // 联系号码
                            phone_number,
                            // 法人出资金额
                            investment_money,
                            // 法人出资截止日期
                            subscribe_endtime,
                            // 法人营业执照
                            business_license_url,
                            stockholder_type_id,
                            business_term,
                            stockholder_djjg,
                            registerno,
                            registermoney,
                            // 状态
                            edit_code,
                            id,
                            area_ids,
                            address,
                            frdbname,
                            frdb_id_card_number,
                            is_bensheng,
                            hehuo_type,
                            hehuo_is_frdb,
                            hehuo_license,
                            hehuo_frdb_name,
                            hehuo_frdb_num
                        })
                    } else {
                        delete item.corporate_credit_code
                        delete item.business_license_url
                        delete item.stockholder_type_id
                        delete item.business_term
                        delete item.registerno
                        delete item.registermoney
                        delete item.stockholder_djjg
                        delete item.hehuo_is_frdb
                        delete item.hehuo_frdb_name
                        delete item.hehuo_frdb_num
                        formState.person_list.person.push(item)
                    }
                })
            } else {
                formState.person_list.person = [...state.shareOwnershipTableData, ...state.shareOwnershipTableDeleteData]
            }
            //如果不使用平台联络员手机号则清空
            if (formState.pt_lly_phone_check != 1) {
                formState.pt_lly_phone = ''
            }

            // formState.isLocalIpAddress = state.isLocalIpAddress
            state.confirmLoading = true
            formState.upload_path = `public/uploads/注册/${state.uploadPathObj.platformCompanyName}/客户资料/${state.uploadPathObj.mainTypeName}/${state.uploadPathObj.date}/${state.uploadPathObj.companyName}/`
            if (props.tableColumnsData?.id && !props.tableColumnsData.isCopy) {
                let data = cloneDeep(formState)
                if (data.verify_time) data.verify_time = dayjs(data.verify_time).format('YYYY-MM-DD')
                data.enter_endtime = dayjs(data.enter_endtime).format('YYYY-MM-DD')
                data.founding_time = dayjs(data.founding_time).format('YYYY-MM-DD')
                data.enter_starttime = dayjs(data.enter_starttime).format('YYYY-MM-DD')
                let requeryParam = {
                    url: '/admin/v1/customer/' + props.tableColumnsData.id,
                    method: 'put',
                    data: data
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        message.success(res.msg)
                        state.confirmLoading = false
                        emit('ok')
                    })
                    .catch((res) => {
                        if (res) {
                            state.confirmLoading = false
                            if (res.msg) {
                                message.warning(res.msg)
                                return
                            }
                            message.warning('参数错误,请检查')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/customer',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        message.success(res.msg)
                        state.confirmLoading = false
                        emit('ok')
                    })
                    .catch((res) => {
                        if (res) {
                            state.confirmLoading = false
                            if (res.msg) {
                                message.warning(res.msg)
                                return
                            }
                            message.warning('参数错误,请检查')
                        }
                    })
            }
        })
        .catch((val) => {
            console.log(val)
            message.warning('请检查必填项')
        })
}
// 获取邮寄信息
const emailChange = () => {
    if (!formState.xftel) {
        message.warn('请填写续费联系人手机号码再获取邮寄信息')
        return
    }
    state.emailLoading = true
    //   if (state.emailList?.length > 0) {
    //     let obj: any = {}
    //     if (state.emailIndex == state.emailList.length - 1) {
    //       obj = state.emailList[0]
    //       state.emailIndex = 0
    //     } else {
    //       obj = state.emailList[state.emailIndex + 1]
    //     }
    //     formState.recipient_name = obj.name
    //     formState.recipient_mobile = obj.tel
    //     formState.recipient_address = obj.address
    //     formState.recipient_area_ids = `${obj.recipient_province_id},${obj.recipient_city_id},${obj.recipient_area_id}`
    //     state.emailLoading = false
    //     message.success('获取成功')
    //   } else {
    let requeryParam = {
        url: '/admin/v1/mailingAddressList',
        method: 'post',
        data: {
            page: 1,
            limit: 'all',
            customer_tel: formState.xftel
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.emailIndex = 0
            state.emailList = res.data.list
            if (res.data.list?.length > 0) {
                formState.recipient_name = res.data.list[0].name
                formState.recipient_mobile = res.data.list[0].tel
                formState.recipient_address = res.data.list[0].address
                formState.recipient_area_ids = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
            }
            message.success(res.msg)
            state.emailLoading = false
        })
        .catch((res) => {
            if (res) {
                state.emailLoading = false
                if (res.msg) {
                    message.warning(res.msg)
                    return
                }
            }
        })
    //   }
}
// 显示活动详情
const showActivityDetail = (act) => {
    state.activityDetail = act.intro
    state.activityDetailVisible = true
}
const activityDetailCancel = () => {
    state.activityDetail = ''
    state.activityDetailVisible = false
}
//判断参加活动的条件
watch(
    () => [formState.registration_type, formState.fee_standard, formState.main_type, formState.business_type, state.platformObj],
    (val) => {
        //如果平台有活动
        if (state.platformObj.is_activity == 1) {
            state.platformObj.can_activity = false //默认一个都不符合条件
            state.platformObj.activity_list.forEach((item) => {
                if (
                    item.business_types.includes(formState.business_type) &&
                    item.registration_types.includes(formState.registration_type) &&
                    item.main_types.includes(formState.main_type) &&
                    item.fee_standards.includes(formState.fee_standard)
                ) {
                    item.can_activity = true
                    state.platformObj.can_activity = true
                } else {
                    item.can_activity = false
                }
            })
        }
        //判断目前选中的内容,如果付款了，则不能改活动
        if (!formState.first_pay_time) {
            if (formState.is_activity != 'bucanjia_0') {
                if (!state.platformObj.can_activity) {
                    formState.is_activity = 'bucanjia_0'
                    Modal.warning({
                        title: '活动提示',
                        content: '活动信息发生改变，请留意观察！'
                    })
                } else {
                    state.platformObj.activity_list.forEach((item) => {
                        if (item.value == formState.is_activity && !item.can_activity) {
                            formState.is_activity = 'bucanjia_0'
                            Modal.warning({
                                title: '活动提示',
                                content: '活动信息发生改变，请留意观察！'
                            })
                        }
                    })
                }
            }
        }
    }
)
//新增电子化账号
const addAccount = () => {
    state.dzhAccountVisible = true
}
// 关闭电子化账号窗口
const dzhAccountCancel = () => {
    state.dzhAccountVisible = false
}
// 成功添加电子化账号的回调
const dzhAccountChange = (dzhAccount) => {
    state.dzhAccountVisible = false
    formState.dzh_account_id = dzhAccount.id
}

const receiveAddressChange = () => {
    if (formState.recipient_address) {
        checkdatastate.recipient_address = state.oldshengshiqu == formState.recipient_address ? 'error' : 'success'
    } else {
        checkdatastate.recipient_address = formState.licenAcceptType == 2 ? 'error' : ''
    }

    //   if (formState.recipient_area_ids) {
    //     let arr = formState.recipient_area_ids.split(',')
    //     let requestParam = {
    //       url: '/admin/areaList?province=' + arr[0] + '&city=' + arr[1] + '&area=' + arr[2],
    //       method: 'get'
    //     }
    //     baseService(requestParam).then((res: any) => {
    //       if (res.data.length == 3) {
    //         let head3 = res.data[0].name + res.data[1].name + res.data[2].name
    //         let head2 = res.data[1].name + res.data[2].name
    //         let head1 = res.data[2].name
    //         formState.recipient_address = formState.recipient_address + ''
    //         formState.recipient_address = formState.recipient_address.trim()
    //         if (formState.recipient_address.indexOf(head3) == 0) {
    //           formState.recipient_address = formState.recipient_address.replace(head3, '')
    //         } else if (formState.recipient_address.indexOf(head2) == 0) {
    //           formState.recipient_address = formState.recipient_address.replace(head2, '')
    //         } else if (formState.recipient_address.indexOf(head1) == 0) {
    //           formState.recipient_address = formState.recipient_address.replace(head1, '')
    //         }
    //         formState.recipient_address = head3 + formState.recipient_address
    //       }
    //     })
    //   }
}
const resetfeedback = () => {
    if (formState.licenAcceptType == 2) {
        checkdatastate.recipient_name = formState.recipient_name ? 'success' : 'error'
    } else {
        checkdatastate.recipient_name = formState.recipient_name ? 'success' : ''
    }
    //验证手机号码
    if (formState.recipient_mobile) {
        let str = formState.recipient_mobile.replaceAll(/\D/g, '')
        //判断str是不是手机号码
        if (!/^1[23456789]\d{9}$/.test(str)) {
            checkdatastate.recipient_mobile = 'error'
        } else {
            checkdatastate.recipient_mobile = 'success'
            formState.recipient_mobile = str
        }
    } else {
        checkdatastate.recipient_mobile = formState.licenAcceptType == 2 ? 'error' : ''
    }
    //验证省市区
    if (!formState.recipient_area_ids) {
        checkdatastate.recipient_area_ids = formState.licenAcceptType == 2 ? 'error' : ''
    }
    //验证address
    if (!formState.recipient_address) {
        checkdatastate.recipient_address = formState.licenAcceptType == 2 ? 'error' : ''
    }
}
const formatAndVerify = () => {
    formState.business_scope = formState.business_scope.replace(/，|,/g, ';');
    setTimeout(() => {
        verificationClick('click');
    }, 100);
}

//识别收货地址
const parseReceiveAddress = () => {
    state.parseReceiveAddressLoading = true
    parseAddress(formState.recipient_address).then((res: any) => {
        if (res.name) {
            formState.recipient_name = res.name
        }
        if (res.phone) {
            formState.recipient_mobile = res.phone
        }
        if (res.area_ids) {
            formState.recipient_area_ids = res.area_ids
        }
        if (res.address) {
            formState.recipient_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading = false
    })
}
const safecheck = () => {
    if (!formState.platform_id) {
        message.error('请选择平台')
        return
    }
    if (!principalName.value.state.name_division) {
        message.error('请输入【名称区划】后再点自动获取')
        return
    }
    if (!principalName.value.state.name_word_mark) {
        message.error('请输入【字号】后再点自动获取')
        return
    }
    if (!principalName.value.state.ondustry_keyword) {
        message.error('请输入【行业】后再点自动获取')
        return
    }
    if (!principalName.value.state.organizational_form) {
        message.error('请输入【组织形式】后再点自动获取')
        return
    }
    if (!formState.social_credit_code) {
        message.error('请输入【统一社会信用代码】后再点自动获取')
        return
    }
    state.loading = true
    state.tip = '初始化中，请稍后...'
    let requestParam = {
        url: '/admin/v1/customerSafecheck',
        method: 'post',
        data: {
            full_name: formState.entityNameToRegister.full_name,
            platform_id: formState.platform_id,
            main_type: formState.main_type,
            postfix: formState.postfix,
        }
    }
    baseServicePlus(requestParam, state.safecheckInterval)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.loading = false
        })

}
</script>

<style lang="less" scoped>
.category {
    padding: 30px 0;
    display: flex;
    justify-content: space-around;

    :deep(.ant-input-number-handler-wrap) {
        display: none;
    }

    .category-item {
        font-size: 24px;
        cursor: pointer;
        padding: 50px;
        border-radius: 15px;
        width: 100%;
        margin-right: 20px;
        text-align: center;
    }

    .company {
        border: 1px solid #e0f9f2;
        background: #e0f9f2;
        color: #00d097;
    }

    .company.check {
        border: 1px solid #00d097;
    }

    .individual {
        background: #e8f1ff;
        color: #3f8cff;
        border: 1px solid #e8f1ff;
    }

    .individual.check {
        border: 1px solid #3f8cff;
    }

    .proprietorship {
        border: 1px solid #e6fffb;
        background: #e6fffb;
        color: #13c2c2;
    }

    .proprietorship.check {
        border: 1px solid #13c2c2;
    }
}

.platform-label {
    line-height: 32px;
    max-width: 102px;
    display: flex;
    justify-content: end;
}

.platform {
    :deep(.ant-form-item-label) {
        display: none;
    }

    :deep(.ant-form-item .ant-form-item-label > label.ant-form-item-no-colon::after) {
        display: none;
    }
}

.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.add-button {
    position: absolute;
    right: 70px;
    top: 10px;
}

.positionItem {
    display: inline-block;
    margin: 5px 0;
}

// 通过标签样式
.range {
    display: inline-block;
    box-sizing: border-box;
    height: auto;
    margin-right: 8px;
    margin-bottom: 4px;
    padding: 4px 7px;
    font-size: 12px;
    font-variant: tabular-nums;
    line-height: 20px;
    white-space: inherit;
    list-style: none;
    border-radius: 2px;
}

.pass-through {
    color: #5ca200 !important;
    background: #f6ffe4 !important;
    border: 1px solid #bad092 !important;
}

.no-pass {
    color: #ff6e03 !important;
    background: #fff5e7 !important;
    border: 1px solid #ffc067 !important;
}

:deep(.ant-modal-title) {
    font-size: 20px;
}

.share-ownership {
    min-width: 1100px;
    margin-top: 50px;
    position: relative;
    display: flex;
    justify-content: center;

    .ownership-table {
        margin-bottom: 30px;
        width: 90%;
    }
}
</style>
